import { SVGProps } from 'react';

/**
 * SVG Icon Components
 * Each icon is a 512x512 viewBox SVG
 */

export const grainsIcons: Record<string, React.FC<SVGProps<SVGSVGElement>>> = {
  flour: (props) => (
    <svg
      height="512"
      viewBox="0 0 74 74"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      data-name="line color"
      {...props}
    >
      <path
        d="m65.779 61.837h-.037a.5.5 0 0 1 -.462-.535c.015-.206.025-.408.036-.608l.021-.385a.507.507 0 0 1 .529-.469.5.5 0 0 1 .469.529l-.021.376c-.011.208-.021.417-.037.63a.5.5 0 0 1 -.498.462z"
        fill="#323c6b"
      ></path>
      <path
        d="m63.916 73.358a.5.5 0 0 1 -.218-.95 5.354 5.354 0 0 0 2.895-3.662 5.251 5.251 0 0 0 -1.123-4.668.5.5 0 1 1 .754-.656 6.241 6.241 0 0 1 1.344 5.546 6.351 6.351 0 0 1 -3.436 4.34.5.5 0 0 1 -.216.05z"
        fill="#323c6b"
      ></path>
      <path
        d="m14.757 30.348c-2.684 5.82-6.076 17.295-2.961 34.641a.127.127 0 0 1 -.031.02 2.863 2.863 0 0 0 1.27 5.43 280.347 280.347 0 0 0 48.319 0 2.863 2.863 0 0 0 1.27-5.43.127.127 0 0 1 -.031-.02c3.115-17.346-.277-28.821-2.951-34.641z"
        fill="#e2b68d"
      ></path>
      <g opacity=".4">
        <path
          d="m62.625 65.01a.127.127 0 0 1 -.031-.021c3.115-17.346-.277-28.821-2.951-34.641h-3.133c2.162 6.466 3.881 16.629 1.369 30.615a.127.127 0 0 0 .031.021 2.863 2.863 0 0 1 -1.271 5.43 280.308 280.308 0 0 1 -46.307.152 2.884 2.884 0 0 0 2.7 3.874 280.34 280.34 0 0 0 48.319 0 2.863 2.863 0 0 0 1.274-5.43z"
          fill="#b98c6c"
        ></path>
      </g>
      <path
        d="m37.029 43.382a3.559 3.559 0 0 0 1.007 5.674 3.559 3.559 0 0 0 -1.007-5.674z"
        fill="#fcd462"
      ></path>
      <path
        d="m38.036 49.556a.5.5 0 0 1 -.243-.062 4.057 4.057 0 0 1 -1.142-6.439.5.5 0 0 1 .62-.11 4.057 4.057 0 0 1 1.143 6.439.5.5 0 0 1 -.378.172zm-.89-5.513a3 3 0 0 0 .772 4.351 3 3 0 0 0 -.772-4.351z"
        fill="#323c6b"
      ></path>
      <path
        d="m43.784 48.467a3.559 3.559 0 0 1 -5.732.6 3.559 3.559 0 0 1 5.732-.6z"
        fill="#fcd462"
      ></path>
      <path
        d="m40.717 50.749a4.265 4.265 0 0 1 -3.017-1.326.5.5 0 0 1 -.066-.627 4.057 4.057 0 0 1 6.5-.683.5.5 0 0 1 .066.627 4.2 4.2 0 0 1 -3.079 1.987 3.8 3.8 0 0 1 -.404.022zm-2-1.75a3 3 0 0 0 4.4-.461 3 3 0 0 0 -4.4.461z"
        fill="#323c6b"
      ></path>
      <path
        d="m34.5 45.542a4.162 4.162 0 0 0 1.178 6.637 4.162 4.162 0 0 0 -1.178-6.637z"
        fill="#fcd462"
      ></path>
      <path
        d="m35.682 52.679a.5.5 0 0 1 -.243-.062 4.66 4.66 0 0 1 -1.312-7.4.5.5 0 0 1 .621-.11 4.661 4.661 0 0 1 1.313 7.4.5.5 0 0 1 -.379.172zm-1.06-6.479a3.605 3.605 0 0 0 .944 5.323 3.605 3.605 0 0 0 -.944-5.323z"
        fill="#323c6b"
      ></path>
      <path
        d="m42.406 51.49a4.162 4.162 0 0 1 -6.7.7 4.162 4.162 0 0 1 6.7-.7z"
        fill="#fcd462"
      ></path>
      <path
        d="m38.819 54.075a4.905 4.905 0 0 1 -3.469-1.526.5.5 0 0 1 -.066-.627 4.66 4.66 0 0 1 7.475-.785.5.5 0 0 1 .066.627 4.824 4.824 0 0 1 -3.539 2.287 4.42 4.42 0 0 1 -.467.024zm-2.453-1.95a3.606 3.606 0 0 0 5.377-.564 3.606 3.606 0 0 0 -5.377.564z"
        fill="#323c6b"
      ></path>
      <path
        d="m31.851 48.5a4.451 4.451 0 0 0 1.259 7.1 4.451 4.451 0 0 0 -1.259-7.1z"
        fill="#fcd462"
      ></path>
      <path
        d="m33.11 56.095a.5.5 0 0 1 -.243-.062 4.95 4.95 0 0 1 -1.395-7.862.5.5 0 0 1 .62-.11 4.95 4.95 0 0 1 1.4 7.862.5.5 0 0 1 -.382.172zm-1.143-6.943a3.9 3.9 0 0 0 1.027 5.788 3.895 3.895 0 0 0 -1.027-5.788z"
        fill="#323c6b"
      ></path>
      <path
        d="m40.3 54.858a4.451 4.451 0 0 1 -7.169.753 4.451 4.451 0 0 1 7.169-.753z"
        fill="#fcd462"
      ></path>
      <path
        d="m36.464 57.587a5.211 5.211 0 0 1 -3.686-1.622.5.5 0 0 1 -.066-.627 4.949 4.949 0 0 1 7.941-.834.5.5 0 0 1 .066.627 5.128 5.128 0 0 1 -3.759 2.43 4.845 4.845 0 0 1 -.496.026zm-2.671-2.045a3.894 3.894 0 0 0 5.846-.614 3.894 3.894 0 0 0 -5.846.614z"
        fill="#323c6b"
      ></path>
      <path
        d="m43.146 42.286a3.559 3.559 0 0 0 -3.466 4.6 3.559 3.559 0 0 0 3.466-4.6z"
        fill="#fcd462"
      ></path>
      <g fill="#323c6b">
        <path d="m39.68 47.39a.5.5 0 0 1 -.485-.379 4.057 4.057 0 0 1 3.934-5.224.5.5 0 0 1 .5.379 4.057 4.057 0 0 1 -3.929 5.223zm3.062-4.567a3 3 0 0 0 -2.658 3.531 3 3 0 0 0 2.658-3.531z"></path>
        <path d="m30.937 59a.5.5 0 0 1 -.4-.8l8.743-11.611a.5.5 0 1 1 .8.6l-8.743 11.611a.5.5 0 0 1 -.4.2z"></path>
        <path d="m37.2 71.978c-8.084 0-16.173-.346-24.206-1.04a3.365 3.365 0 0 1 -1.748-6.213c-3.085-17.609.585-29.217 3.062-34.586a.5.5 0 0 1 .454-.291h44.881a.5.5 0 0 1 .454.291c2.471 5.377 6.134 16.995 3.052 34.585a3.278 3.278 0 0 1 1.493 3.576 3.325 3.325 0 0 1 -3.288 2.637c-8.005.695-16.078 1.041-24.154 1.041zm-22.12-41.13c-2.441 5.422-5.886 16.828-2.792 34.052a.5.5 0 0 1 -.139.442.756.756 0 0 1 -.161.114 2.272 2.272 0 0 0 -1.266 2.624 2.316 2.316 0 0 0 2.313 1.859 281.619 281.619 0 0 0 48.276 0 2.334 2.334 0 0 0 2.355-1.861 2.269 2.269 0 0 0 -1.258-2.621.743.743 0 0 1 -.168-.118.5.5 0 0 1 -.14-.439c3.089-17.205-.347-28.623-2.781-34.053z"></path>
      </g>
      <path
        d="m15.791 59.461a.7.7 0 0 1 -.7-.63 69.309 69.309 0 0 1 -.256-11.08.708.708 0 0 1 .741-.657.7.7 0 0 1 .657.741 67.985 67.985 0 0 0 .251 10.855.7.7 0 0 1 -.7.771z"
        fill="#fff"
      ></path>
      <path
        d="m15.763 45.614a.7.7 0 0 1 -.694-.795q.118-.864.257-1.686a.708.708 0 0 1 .806-.575.7.7 0 0 1 .575.806q-.135.8-.251 1.644a.7.7 0 0 1 -.693.606z"
        fill="#fff"
      ></path>
      <path
        d="m58.965 19.453c0 2.69-9.75 4.87-21.77 4.87s-21.77-2.18-21.77-4.87 9.75-4.47 21.77-4.47 21.77 1.78 21.77 4.47z"
        fill="#c49474"
      ></path>
      <path
        d="m37.195 24.823c-10.8 0-22.27-1.882-22.27-5.37 0-3.434 11.185-4.97 22.27-4.97s22.27 1.537 22.27 4.97c0 3.488-11.474 5.37-22.27 5.37zm0-9.34c-13.138 0-21.27 2.061-21.27 3.97 0 2.067 8.735 4.37 21.27 4.37s21.27-2.3 21.27-4.37c0-1.909-8.132-3.97-21.27-3.97z"
        fill="#323c6b"
      ></path>
      <path
        d="m23.921 8.223a.5.5 0 0 1 -.3-.9 14.53 14.53 0 0 1 1.334-.912.5.5 0 0 1 .514.857 13.672 13.672 0 0 0 -1.243.851.5.5 0 0 1 -.305.104z"
        fill="#323c6b"
      ></path>
      <path
        d="m27.831 6a.5.5 0 0 1 -.207-.956l.637-.287a15.787 15.787 0 0 0 3.4-1.831c.146-.118.287-.243.428-.367a9.959 9.959 0 0 1 2.736-1.876.5.5 0 0 1 .395.919 8.967 8.967 0 0 0 -2.427 1.673c-.195.172-.346.306-.5.433a16.435 16.435 0 0 1 -3.62 1.968l-.632.284a.5.5 0 0 1 -.21.04z"
        fill="#323c6b"
      ></path>
      <path
        d="m56.968 23.392c-4.158 1.77-11.682 2.466-19.764 2.466-8.189 0-15.949-.782-20.075-2.584.789-1.493 2.93-3.024 3.943-4.463a18.6 18.6 0 0 0 1.909-4.311 10.491 10.491 0 0 1 1.461-2.857c2.292-2.983 6.632-3.463 9.558-5.843a9.912 9.912 0 0 1 2.292-1.717 5.811 5.811 0 0 1 1.919-.394c2.314-.192 5.065.032 6.3 1.994.725 1.152.714 2.612 1.194 3.892.682 1.791 2.271 3.039 3.433 4.553.075.085.139.171.2.256 1.375 1.909 2.079 4.372 3.977 5.747a15.263 15.263 0 0 1 3.653 3.261z"
        fill="#eeefee"
      ></path>
      <path
        d="m35.513 5.559c2.314-.192 5.065.032 6.3 1.994.725 1.152.714 2.612 1.194 3.892.682 1.791 2.271 3.039 3.433 4.553.075.085.139.171.2.256 1.375 1.909 2.079 4.372 3.977 5.747a23.538 23.538 0 0 1 3 2.438 20.769 20.769 0 0 0 3.349-1.047 15.262 15.262 0 0 0 -3.653-3.259c-1.9-1.375-2.6-3.838-3.977-5.747-.064-.085-.128-.171-.2-.256-1.162-1.514-2.751-2.761-3.433-4.553-.48-1.279-.469-2.74-1.194-3.892-1.237-1.962-3.988-2.186-6.3-1.994a5.812 5.812 0 0 0 -1.919.394 9.911 9.911 0 0 0 -2.29 1.715l-.015.011a7.067 7.067 0 0 1 1.528-.252z"
        fill="#e1e6e9"
      ></path>
      <path
        d="m25.06 10.954c2.075-1.064 4.43-1.809 6.241-3.283.215-.177.425-.365.636-.552-2.362 1.235-5.048 2.014-6.877 3.835z"
        fill="#e1e6e9"
      ></path>
      <path
        d="m37.2 26.358c-5.327 0-15.043-.341-20.275-2.626a.5.5 0 0 1 -.242-.691 12.123 12.123 0 0 1 2.255-2.641 15.068 15.068 0 0 0 1.726-1.875 13.778 13.778 0 0 0 1.543-3.354c.1-.281.2-.562.306-.841a10.92 10.92 0 0 1 1.534-2.988c1.393-1.815 3.488-2.748 5.514-3.651a18.207 18.207 0 0 0 4.119-2.276c.177-.147.354-.3.53-.461a6.982 6.982 0 0 1 1.883-1.329 6.249 6.249 0 0 1 2.073-.432c3.383-.276 5.657.469 6.764 2.226a7.327 7.327 0 0 1 .844 2.475 10.427 10.427 0 0 0 .4 1.508 9.839 9.839 0 0 0 2.12 2.98c.42.461.854.938 1.242 1.443.061.068.13.16.2.251a20.032 20.032 0 0 1 1.328 2.224 9.631 9.631 0 0 0 2.544 3.425l.269.2a14.213 14.213 0 0 1 3.523 3.208.5.5 0 0 1 -.232.719c-4.868 2.071-13.544 2.506-19.968 2.506zm-19.333-3.322c3.838 1.479 10.82 2.322 19.337 2.322 8.486 0 15.176-.776 18.979-2.192a18.179 18.179 0 0 0 -2.895-2.434l-.269-.2a10.508 10.508 0 0 1 -2.834-3.757 19.278 19.278 0 0 0 -1.253-2.1c-.055-.073-.109-.146-.173-.219-.383-.5-.8-.958-1.208-1.4a10.732 10.732 0 0 1 -2.316-3.3 11.308 11.308 0 0 1 -.435-1.656 6.479 6.479 0 0 0 -.712-2.147c-.892-1.416-2.855-2.008-5.836-1.762a5.433 5.433 0 0 0 -1.757.353 6.134 6.134 0 0 0 -1.62 1.156c-.186.165-.372.33-.561.487a18.947 18.947 0 0 1 -4.346 2.413c-2 .891-3.889 1.733-5.129 3.348a10.042 10.042 0 0 0 -1.388 2.726c-.1.277-.2.554-.3.83a14.736 14.736 0 0 1 -1.669 3.596 15.945 15.945 0 0 1 -1.843 2.015 16.077 16.077 0 0 0 -1.772 1.921z"
        fill="#323c6b"
      ></path>
      <path
        d="m57.045 31.893c-4.68 1.38-11.93 2.21-19.85 2.21s-15.17-.83-19.85-2.21a5.176 5.176 0 0 1 -3.79-6.47l1.87-5.97c0 2.69 9.75 4.87 21.77 4.87s21.77-2.18 21.77-4.87l1.87 5.97a5.176 5.176 0 0 1 -3.79 6.47z"
        fill="#e2b68d"
      ></path>
      <path
        d="m37.195 34.6c-7.9 0-15.184-.813-19.992-2.23a6.155 6.155 0 0 1 -3.771-3.006 5.245 5.245 0 0 1 -.352-4.1l1.868-5.964a.5.5 0 0 1 .977.149c0 2.067 8.735 4.37 21.27 4.37s21.27-2.3 21.27-4.37a.5.5 0 0 1 .424-.494.5.5 0 0 1 .553.345l1.87 5.97a5.241 5.241 0 0 1 -.354 4.093 6.152 6.152 0 0 1 -3.771 3.006c-4.808 1.421-12.095 2.231-19.992 2.231zm-21.664-13.813-1.5 4.786a4.256 4.256 0 0 0 .285 3.33 5.162 5.162 0 0 0 3.17 2.512c4.719 1.392 11.9 2.189 19.708 2.189s14.988-.8 19.708-2.189a5.163 5.163 0 0 0 3.17-2.515 4.256 4.256 0 0 0 .288-3.324l-1.5-4.792c-2.5 2.631-12.336 4.036-21.664 4.036s-19.162-1.402-21.665-4.033z"
        fill="#323c6b"
      ></path>
    </svg>
  ),
  rice: (props) => (
    <svg viewBox="0 0 470 470" xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" {...props}>
      <g>
        <path
          fill="#19ABBF"
          d="M235,447.5c118.798,0,215.906-94.65,219.874-212.5H15.126C19.094,352.85,116.202,447.5,235,447.5z
		 M122.27,361.75c4.146,0,7.504,3.358,7.504,7.5s-3.358,7.5-7.5,7.5c-4.144,0-7.504-3.36-7.504-7.5S118.13,361.75,122.27,361.75z
		 M92.27,331.75c4.146,0,7.504,3.358,7.504,7.5c0,4.142-3.358,7.5-7.5,7.5c-4.144,0-7.504-3.36-7.504-7.5S88.13,331.75,92.27,331.75
		z"
        />
        <path
          fill="#FFFFFF"
          d="M438.696,220c-1.772-4.98-5.268-9.283-9.978-12.001c-2.021-1.165-3.384-3.204-3.688-5.518
		c-0.304-2.313,0.485-4.635,2.135-6.284c5.683-5.679,7.925-14.015,5.851-21.755c-2.074-7.74-8.184-13.839-15.946-15.916
		c-2.253-0.604-4.098-2.221-4.99-4.375c-0.893-2.155-0.731-4.603,0.436-6.622c4.02-6.957,4.028-15.59,0.021-22.529
		c-4.005-6.938-11.481-11.246-19.513-11.246c-2.343,0-4.542-1.084-5.961-2.934c-1.42-1.851-1.898-4.257-1.293-6.51
		c2.082-7.761-0.145-16.102-5.811-21.767c-5.667-5.667-14.007-7.896-21.768-5.812c-2.252,0.604-4.659,0.126-6.509-1.294
		s-2.935-3.62-2.934-5.953c0.002-8.034-4.307-15.515-11.246-19.521c-6.94-4.007-15.573-3.998-22.529,0.021
		c-2.019,1.166-4.466,1.327-6.623,0.435c-2.155-0.893-3.772-2.736-4.375-4.99c-2.077-7.761-8.176-13.871-15.916-15.946
		c-7.739-2.074-16.076,0.169-21.756,5.853c-1.648,1.649-3.973,2.438-6.284,2.134c-2.313-0.305-4.352-1.668-5.518-3.688
		C250.485,26.823,243.014,22.5,235,22.5s-15.485,4.323-19.5,11.282c-1.166,2.021-3.205,3.384-5.518,3.688
		c-2.311,0.304-4.635-0.483-6.284-2.134c-5.681-5.685-14.018-7.925-21.757-5.853c-7.74,2.075-13.839,8.186-15.916,15.946
		c-0.603,2.254-2.22,4.098-4.375,4.99c-2.156,0.894-4.603,0.732-6.623-0.435c-6.957-4.02-15.588-4.027-22.529-0.021
		c-6.939,4.006-11.249,11.486-11.246,19.521c0.001,2.333-1.084,4.533-2.934,5.953c-1.851,1.418-4.257,1.896-6.509,1.294
		c-7.759-2.081-16.102,0.145-21.767,5.811c-5.667,5.666-7.893,14.007-5.811,21.768c0.604,2.253,0.126,4.659-1.293,6.51
		c-1.419,1.85-3.619,2.934-5.95,2.934c-8.043,0-15.519,4.309-19.524,11.246c-4.007,6.939-3.999,15.572,0.021,22.529
		c1.167,2.02,1.328,4.467,0.436,6.622c-0.893,2.154-2.737,3.771-4.99,4.375c-7.762,2.077-13.872,8.176-15.946,15.916
		s0.168,16.076,5.851,21.755c1.65,1.649,2.439,3.972,2.135,6.284c-0.305,2.313-1.668,4.353-3.688,5.518
		c-4.71,2.718-8.206,7.021-9.978,12.001H438.696z M334.27,144.5c4.146,0,7.504,3.358,7.504,7.5c0,4.142-3.358,7.5-7.5,7.5
		c-4.144,0-7.504-3.36-7.504-7.5S330.13,144.5,334.27,144.5z M134.27,114.5c4.146,0,7.504,3.358,7.504,7.5
		c0,4.142-3.358,7.5-7.5,7.5c-4.144,0-7.504-3.36-7.504-7.5S130.13,114.5,134.27,114.5z M134.27,174.5
		c4.146,0,7.504,3.358,7.504,7.5s-3.358,7.5-7.5,7.5c-4.144,0-7.504-3.36-7.504-7.5S130.13,174.5,134.27,174.5z M104.27,144.5
		c4.146,0,7.504,3.358,7.504,7.5c0,4.142-3.358,7.5-7.5,7.5c-4.144,0-7.504-3.36-7.504-7.5S100.13,144.5,104.27,144.5z"
        />
        <path
          fill="#1C1918"
          d="M470,227.5c0-4.143-3.358-7.5-7.5-7.5h-8.269c-1.567-7.614-5.473-14.585-11.143-19.896
		c5.419-8.715,7.125-19.434,4.416-29.545c-2.709-10.11-9.546-18.54-18.597-23.378c2.98-9.822,1.854-20.616-3.381-29.682
		c-5.234-9.066-14.018-15.439-24.014-17.769c0.336-10.258-3.546-20.394-10.948-27.794c-7.402-7.403-17.533-11.303-27.795-10.949
		c-2.33-9.996-8.703-18.78-17.769-24.014c-9.065-5.234-19.86-6.358-29.681-3.382c-4.838-9.051-13.267-15.887-23.379-18.597
		c-10.111-2.709-20.829-1.004-29.544,4.416C255.38,11.922,245.468,7.5,235,7.5s-20.38,4.422-27.396,11.912
		c-8.715-5.419-19.435-7.126-29.545-4.416c-10.111,2.71-18.541,9.546-23.378,18.597c-9.82-2.979-20.616-1.853-29.681,3.382
		c-9.066,5.233-15.439,14.018-17.769,24.014c-10.266-0.346-20.394,3.546-27.795,10.948c-7.402,7.401-11.284,17.537-10.948,27.795
		c-9.995,2.33-18.78,8.703-24.014,17.769c-5.234,9.065-6.361,19.859-3.381,29.682c-9.051,4.838-15.888,13.268-18.597,23.379
		c-2.709,10.111-1.003,20.829,4.416,29.544c-5.67,5.31-9.576,12.281-11.143,19.896H7.5c-4.142,0-7.5,3.357-7.5,7.5
		c0,62.771,24.444,121.784,68.83,166.17c24.033,24.032,52.359,42.205,83.243,53.83H147.5c-4.142,0-7.5,3.357-7.5,7.5
		s3.358,7.5,7.5,7.5h175c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5h-4.573c30.884-11.625,59.21-29.798,83.243-53.83
		C445.556,349.284,470,290.271,470,227.5z M41.283,207.999c2.021-1.165,3.384-3.204,3.688-5.518
		c0.304-2.313-0.485-4.635-2.135-6.284c-5.683-5.679-7.925-14.015-5.851-21.755s8.184-13.839,15.946-15.916
		c2.253-0.604,4.098-2.221,4.99-4.375c0.893-2.155,0.731-4.603-0.436-6.622c-4.02-6.957-4.028-15.59-0.021-22.529
		c4.005-6.938,11.481-11.246,19.513-11.246c2.343,0,4.542-1.084,5.961-2.934c1.42-1.851,1.898-4.257,1.293-6.51
		c-2.082-7.761,0.145-16.102,5.811-21.768c5.666-5.666,14.008-7.892,21.767-5.811c2.252,0.603,4.659,0.124,6.509-1.294
		c1.85-1.42,2.935-3.62,2.934-5.953c-0.002-8.034,4.307-15.515,11.246-19.521c6.941-4.006,15.572-3.998,22.529,0.021
		c2.02,1.167,4.467,1.328,6.623,0.435c2.155-0.893,3.772-2.736,4.375-4.99c2.077-7.761,8.176-13.871,15.916-15.946
		c7.739-2.072,16.076,0.168,21.757,5.853c1.648,1.65,3.973,2.438,6.284,2.134c2.313-0.305,4.352-1.668,5.518-3.688
		C219.515,26.823,226.986,22.5,235,22.5s15.485,4.323,19.5,11.282c1.166,2.021,3.205,3.384,5.518,3.688
		c2.311,0.304,4.635-0.484,6.284-2.134c5.681-5.684,14.017-7.927,21.756-5.853c7.74,2.075,13.839,8.186,15.916,15.946
		c0.603,2.254,2.22,4.098,4.375,4.99c2.156,0.893,4.604,0.731,6.623-0.435c6.957-4.02,15.589-4.028,22.529-0.021
		c6.939,4.006,11.248,11.486,11.246,19.521c-0.001,2.333,1.084,4.533,2.934,5.953s4.257,1.898,6.509,1.294
		c7.761-2.085,16.101,0.145,21.768,5.812c5.666,5.665,7.893,14.006,5.811,21.767c-0.604,2.253-0.126,4.659,1.293,6.51
		c1.42,1.85,3.619,2.934,5.95,2.934c8.042,0,15.519,4.309,19.524,11.246c4.007,6.939,3.999,15.572-0.021,22.529
		c-1.167,2.02-1.328,4.467-0.436,6.622c0.893,2.154,2.737,3.771,4.99,4.375c7.762,2.077,13.872,8.176,15.946,15.916
		c2.074,7.74-0.168,16.076-5.851,21.755c-1.65,1.649-2.439,3.972-2.135,6.284c0.305,2.313,1.668,4.353,3.688,5.518
		c4.71,2.718,8.206,7.021,9.978,12.001H31.304C33.077,215.02,36.573,210.717,41.283,207.999z M454.874,235
		C450.906,352.85,353.798,447.5,235,447.5S19.094,352.85,15.126,235H454.874z"
        />
        <circle fill="#1C1918" cx="122.274" cy="369.25" r="7.5" />
        <circle fill="#1C1918" cx="92.274" cy="339.25" r="7.5" />
        <circle fill="#1C1918" cx="134.274" cy="182" r="7.5" />
        <circle fill="#1C1918" cx="104.274" cy="152" r="7.5" />
        <circle fill="#1C1918" cx="334.274" cy="152" r="7.5" />
        <circle fill="#1C1918" cx="134.274" cy="122" r="7.5" />
      </g>
    </svg>
  ),
  pasta: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m336 24v72h-128c24-80 128-72 128-72z" fill="#e6be34" />
      <path d="m160 416s16 8 16 32-24 40-24 40-8-56-48-56l16-32z" fill="#f2c837" />
      <path d="m96 136-16 24-40-8s-16-8-16-32 24-40 24-40 8 56 48 56z" fill="#f2c837" />
      <path
        d="m160 232s16 8 16 32-16 32-16 32 16 8 16 32-16 32-16 32 16 8 16 24-8 24-16 32c-16 16-56 16-56 16-48.66 0-64 56-64 56s-16-16-16-40 16-48 16-48-16-8-16-32 16-32 16-32-16-8-16-32 16-32 16-32-16-8-16-32 16-32 16-32-16-8-16-24 8-24 16-32c16-16 56-16 56-16 48.66 0 64-56 64-56s16 16 16 40-16 48-16 48 16 8 16 32-16 32-16 32z"
        fill="#ffd33a"
      />
      <path
        d="m336 24v392c-3.71 16.68-12.57 29.5-24 39.35-4.92 4.24-10.33 7.94-16 11.15-5.16 2.92-10.55 5.45-16 7.63-5.32 2.13-10.7 3.93-16 5.46-5.47 1.57-10.86 2.85-16 3.9-5.71 1.15-11.11 2.01-16 2.65-14.21 1.86-24 1.86-24 1.86v-392s9.79 0 24-1.86c4.89-.64 10.29-1.5 16-2.65 5.14-1.05 10.53-2.33 16-3.9 5.3-1.53 10.68-3.33 16-5.46 5.45-2.18 10.84-4.71 16-7.63 5.67-3.21 11.08-6.91 16-11.15 11.43-9.85 20.29-22.67 24-39.35z"
        fill="#ffd33a"
      />
      <g fill="#e6be34">
        <path d="m51.259 216.537c-7.152 0-11.577-.514-12.251-.599-4.384-.548-7.494-4.546-6.946-8.93.547-4.379 4.534-7.489 8.916-6.948.604.072 61.348 6.839 113.816-38.134 3.355-2.875 8.405-2.486 11.281.868 2.875 3.355 2.487 8.405-.868 11.281-43.824 37.562-91.872 42.462-113.948 42.462z" />
        <path d="m51.259 280.537c-7.152 0-11.577-.514-12.251-.599-4.384-.548-7.494-4.546-6.946-8.93.547-4.379 4.534-7.491 8.916-6.948.604.072 61.348 6.839 113.816-38.134 3.355-2.875 8.405-2.486 11.281.868 2.875 3.355 2.487 8.405-.868 11.281-43.824 37.562-91.872 42.462-113.948 42.462z" />
        <path d="m51.259 344.537c-7.152 0-11.577-.514-12.251-.599-4.384-.548-7.494-4.546-6.946-8.93.547-4.379 4.534-7.486 8.916-6.948.604.073 61.348 6.839 113.816-38.134 3.355-2.875 8.405-2.486 11.281.868 2.875 3.355 2.487 8.405-.868 11.281-43.824 37.562-91.872 42.462-113.948 42.462z" />
        <path d="m51.259 408.537c-7.152 0-11.577-.514-12.251-.599-4.384-.548-7.494-4.546-6.946-8.93.547-4.379 4.534-7.488 8.916-6.948.604.073 61.348 6.839 113.816-38.134 3.355-2.875 8.405-2.486 11.281.868 2.875 3.355 2.487 8.405-.868 11.281-43.824 37.562-91.872 42.462-113.948 42.462z" />
        <path d="m248 91.49v392c-5.71 1.15-11.11 2.01-16 2.65v-392c4.89-.64 10.29-1.5 16-2.65z" />
        <path d="m280 82.13v392c-5.32 2.13-10.7 3.93-16 5.46v-392c5.3-1.53 10.68-3.33 16-5.46z" />
        <path d="m312 63.35v392c-4.92 4.24-10.33 7.94-16 11.15v-392c5.67-3.21 11.08-6.91 16-11.15z" />
      </g>
      <path
        d="m472 328s-16 16-16 40 16 40 16 40v80s-104 8-104-120 104-120 104-120z"
        fill="#ffd33a"
      />
      <ellipse cx="472" cy="288" fill="#e6be34" rx="16" ry="40" />
      <ellipse cx="472" cy="448" fill="#e6be34" rx="16" ry="40" />
    </svg>
  ),
  spaghetti: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <g>
          <path
            d="m414.455 264.399 1.054-.664c19.143-12.063 24.844-37.383 12.718-56.486l-10.931-17.221c-4.881-7.689-16.101-7.689-20.982 0l-10.931 17.221c-12.126 19.103-6.426 44.423 12.718 56.486l1.054.664c4.673 2.946 10.624 2.946 15.3 0z"
            fill="#41c47d"
          />
        </g>
        <g>
          <path
            d="m389.956 252.847-.993 1.576c-.179.284-.339.575-.503.865 2.681 3.223 5.9 6.091 9.639 8.447l1.054.664c4.675 2.946 10.626 2.946 15.302 0l1.054-.664c13.656-8.605 20.464-23.955 18.848-38.983-17.631 2.136-34.192 11.892-44.401 28.095z"
            fill="#3cb372"
          />
        </g>
        <g>
          <path
            d="m408.269 258.214.664-1.054c12.063-19.143 37.383-24.844 56.486-12.718l17.221 10.931c7.689 4.881 7.689 16.101 0 20.982l-17.221 10.931c-19.103 12.126-44.423 6.426-56.486-12.718l-.664-1.054c-2.946-4.674-2.946-10.625 0-15.3z"
            fill="#41c47d"
          />
        </g>
        <g>
          <path
            d="m226.209 403.32c1.136-5.821 1.745-11.83 1.745-17.984 0-51.67-41.887-93.557-93.557-93.557s-93.557 41.886-93.557 93.557c0 6.154.609 12.163 1.745 17.984z"
            fill="#ffdf74"
          />
        </g>
        <g>
          <path
            d="m347.812 403.32c1.136-5.821 1.745-11.83 1.745-17.984 0-51.67-41.887-93.557-93.557-93.557s-93.557 41.887-93.557 93.557c0 6.154.609 12.163 1.745 17.984z"
            fill="#ffdf74"
          />
        </g>
        <g>
          <path
            d="m469.415 403.32c1.136-5.821 1.745-11.83 1.745-17.984 0-51.67-41.887-93.557-93.557-93.557s-93.557 41.887-93.557 93.557c0 6.154.609 12.163 1.745 17.984z"
            fill="#ffdf74"
          />
        </g>
        <g>
          <g>
            <path
              d="m429.821 490.612 34.692-49.647h-417.026l34.692 49.647c6.081 8.703 16.029 13.887 26.646 13.887h294.35c10.617.001 20.565-5.184 26.646-13.887z"
              fill="#d4d4e8"
            />
          </g>
          <g>
            <path
              d="m464.513 440.965h-417.026l34.692 49.647c6.081 8.703 16.029 13.887 26.646 13.887h31.68c-10.617 0-20.565-5.185-26.646-13.887l-12.699-18.172h341.36z"
              fill="#c6c6e0"
            />
          </g>
          <g>
            <path
              d="m469.5 451.765h-427c-19.33 0-35-15.67-35-35v-17.335c0-8.095 6.562-14.657 14.657-14.657h467.686c8.095 0 14.657 6.562 14.657 14.657v17.336c0 19.329-15.67 34.999-35 34.999z"
              fill="#e9e9ff"
            />
          </g>
          <g>
            <path
              d="m39.18 416.765v-31.993h-17.023c-8.095 0-14.657 6.562-14.657 14.657v17.336c0 19.33 15.67 35 35 35h31.68c-19.33 0-35-15.67-35-35z"
              fill="#d4d4e8"
            />
          </g>
        </g>
        <g>
          <path
            d="m405.543 249.317-57.024-25.08c-58.954-25.929-126.084-25.929-185.038 0l-57.024 25.08c-9.008 3.962-15.155 12.756-15.201 22.596-.064 13.618 10.956 24.678 24.56 24.678h42.874c7.253 0 13.134 5.88 13.134 13.134v12.656c0 13.552 10.986 24.539 24.539 24.539 13.552 0 24.539-10.986 24.539-24.539v-8.041c0-7.254 5.88-13.134 13.134-13.134h57.268c7.253 0 13.134 5.88 13.134 13.134v18.15c0 12.459 10.101 22.56 22.56 22.56 12.459 0 22.56-10.1 22.56-22.56v-22.765c0-7.253 5.88-13.134 13.134-13.134h33.493c13.603 0 24.624-11.06 24.56-24.678-.048-9.84-6.195-18.635-15.202-22.596z"
            fill="#ff415b"
          />
        </g>
        <g>
          <path
            d="m114.117 271.913c.046-9.84 6.193-18.635 15.201-22.596l57.024-25.08c25.913-11.397 53.406-17.78 81.089-19.158-35.299-1.757-70.908 4.626-103.949 19.158l-57.024 25.08c-9.008 3.962-15.155 12.756-15.201 22.596-.064 13.618 10.956 24.678 24.56 24.678h22.86c-13.604 0-24.624-11.06-24.56-24.678z"
            fill="#ef2b55"
          />
        </g>
        <g>
          <path
            d="m194.684 322.381v-12.656c0-7.254-5.88-13.134-13.134-13.134h-22.86c7.254 0 13.134 5.88 13.134 13.134v12.656c0 13.552 10.986 24.539 24.539 24.539 4.128 0 8.016-1.024 11.43-2.825-7.794-4.111-13.109-12.29-13.109-21.714z"
            fill="#ef2b55"
          />
        </g>
        <g>
          <path
            d="m327.297 332.49v-18.15c0-7.254-5.88-13.134-13.134-13.134h-22.86c7.253 0 13.134 5.88 13.134 13.134v18.15c0 12.459 10.101 22.56 22.56 22.56 4.172 0 8.077-1.137 11.43-3.112-6.659-3.922-11.13-11.161-11.13-19.448z"
            fill="#ef2b55"
          />
        </g>
        <g>
          <path
            d="m327.157 247.012c-14.26 0-25.82-11.56-25.82-25.82 0-14.26 11.56-25.82 25.82-25.82 14.26 0 25.82 11.56 25.82 25.82 0 14.26-11.56 25.82-25.82 25.82z"
            fill="#fff3d7"
          />
        </g>
        <g>
          <path
            d="m316.098 221.192c0-11.695 7.777-21.568 18.44-24.744-2.339-.697-4.815-1.076-7.38-1.076-14.26 0-25.82 11.56-25.82 25.82s11.56 25.82 25.82 25.82c2.565 0 5.041-.38 7.38-1.076-10.663-3.176-18.44-13.049-18.44-24.744z"
            fill="#f9dbaa"
          />
        </g>
        <g>
          <path
            d="m134.397 261.665c-14.26 0-25.82-11.56-25.82-25.82 0-14.26 11.56-25.82 25.82-25.82 14.26 0 25.82 11.56 25.82 25.82 0 14.26-11.56 25.82-25.82 25.82z"
            fill="#fff3d7"
          />
        </g>
        <g>
          <path
            d="m123.337 235.845c0-11.695 7.777-21.568 18.44-24.744-2.339-.697-4.815-1.076-7.38-1.076-14.26 0-25.82 11.56-25.82 25.82s11.56 25.82 25.82 25.82c2.565 0 5.041-.38 7.38-1.076-10.663-3.176-18.44-13.049-18.44-24.744z"
            fill="#f9dbaa"
          />
        </g>
        <g>
          <path
            d="m407.889 331.56c-14.26 0-25.82-11.56-25.82-25.82 0-14.26 11.56-25.82 25.82-25.82 14.26 0 25.82 11.56 25.82 25.82 0 14.26-11.56 25.82-25.82 25.82z"
            fill="#fff3d7"
          />
        </g>
        <g>
          <path
            d="m396.829 305.74c0-11.695 7.777-21.568 18.44-24.744-2.339-.697-4.815-1.076-7.38-1.076-14.26 0-25.82 11.56-25.82 25.82 0 14.26 11.56 25.82 25.82 25.82 2.565 0 5.041-.38 7.38-1.076-10.663-3.177-18.44-13.05-18.44-24.744z"
            fill="#f9dbaa"
          />
        </g>
        <g>
          <path
            d="m494.5 62.4h-101.015c-10.31 0-20.308-3.54-28.32-10.029l-6.911-5.597c-8.012-6.489-18.01-10.029-28.32-10.029h-55.022c-7.836 0-14.578 6.022-14.946 13.849-.393 8.356 6.265 15.255 14.535 15.255-8.037 0-14.552 6.515-14.552 14.552s6.515 14.552 14.552 14.552c-8.27 0-14.929 6.899-14.535 15.255.369 7.827 7.111 13.848 14.946 13.848h55.022c10.31 0 20.308-3.54 28.32-10.029l6.911-5.597c8.012-6.489 18.01-10.029 28.32-10.029h101.015c5.523 0 10-4.477 10-10v-16c0-5.524-4.477-10.001-10-10.001z"
            fill="#e9e9ff"
          />
        </g>
        <g>
          <g>
            <path
              d="m224.85 244c-8.649 0-15.66-7.011-15.66-15.66v-205.18c0-8.649 7.011-15.66 15.66-15.66 8.649 0 15.66 7.011 15.66 15.66v205.18c0 8.648-7.012 15.66-15.66 15.66z"
              fill="#ffdf74"
            />
          </g>
          <g>
            <path
              d="m222.96 228.34v-205.18c0-6.175 3.583-11.499 8.775-14.049-2.08-1.021-4.411-1.611-6.885-1.611-8.649 0-15.66 7.011-15.66 15.66v205.18c0 8.649 7.011 15.66 15.66 15.66 2.474 0 4.805-.589 6.885-1.611-5.192-2.55-8.775-7.874-8.775-14.049z"
              fill="#f7ce5c"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="m256.17 149.64c-8.649 0-15.66-7.011-15.66-15.66v-110.82c0-8.649 7.011-15.66 15.66-15.66 8.649 0 15.66 7.011 15.66 15.66v110.82c0 8.648-7.012 15.66-15.66 15.66z"
              fill="#ffdf74"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  macaroni: (props) => (
    <svg
      height="410pt"
      viewBox="0 -60 410.04196 410"
      width="410pt"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m106.3125 154.449219c-21.265625-23.34375-19.574219-59.632813 3.769531-80.898438l-61.542969-67.550781c-60.683593 55.289062-65.0625 149.300781-9.777343 209.988281 55.289062 60.6875 149.300781 65.0625 209.988281 9.777344l-61.539062-67.550781c-23.339844 21.265625-59.632813 19.574218-80.898438-3.765625zm0 0"
        fill="#ffd551"
      ></path>
      <path
        d="m240.984375 171.015625c-16.996094-18.652344-41.070313-24.390625-53.769531-12.820313-12.699219 11.570313-9.21875 36.074219 7.777344 54.726563 16.992187 18.652344 41.066406 24.390625 53.765624 12.820313 12.703126-11.570313 9.21875-36.074219-7.773437-54.726563zm0 0"
        fill="#ffd551"
      ></path>
      <path
        d="m82.199219 232.75c-50.527344-55.460938-51.210938-138.753906-4.632813-194.886719l-29.023437-31.863281c-60.6875 55.289062-65.066407 149.300781-9.777344 209.988281 21.703125 23.824219 49.375 38.964844 78.65625 45.230469-12.808594-7.441406-24.714844-16.9375-35.222656-28.46875zm0 0"
        fill="#ffc34c"
      ></path>
      <path
        d="m248.039062 207.761719c-.164062 3.519531-1.144531 8.429687-4.898437 11.847656-9.125 8.3125-28.359375 2.691406-42-12.277344-8.738281-9.59375-13.679687-21.226562-13.21875-31.117187.164063-3.515625 1.144531-8.425782 4.898437-11.84375 9.128907-8.316406 28.363282-2.691406 42 12.277344 8.738282 9.589843 13.679688 21.222656 13.21875 31.113281zm0 0"
        fill="#ffc34c"
      ></path>
      <path
        d="m102.308594 18.8125c-16.992188-18.652344-41.066406-24.390625-53.765625-12.820312-12.699219 11.570312-9.21875 36.074218 7.773437 54.726562 16.996094 18.652344 41.070313 24.390625 53.769532 12.820312 12.699218-11.570312 9.21875-36.074218-7.777344-54.726562zm0 0"
        fill="#ffd551"
      ></path>
      <path
        d="m109.371094 55.546875c-.164063 3.519531-1.148438 8.425781-4.898438 11.847656-9.128906 8.3125-28.363281 2.691407-42.003906-12.277343-8.738281-9.59375-13.679688-21.226563-13.21875-31.117188.164062-3.515625 1.148438-8.425781 4.898438-11.84375 9.128906-8.316406 28.363281-2.691406 42 12.277344 8.738281 9.59375 13.683593 21.222656 13.222656 31.113281zm0 0"
        fill="#ffc34c"
      ></path>
      <path
        d="m114.023438 197.304688c0 8.835937-7.160157 15.996093-15.996094 15.996093-8.832032 0-15.996094-7.160156-15.996094-15.996093 0-8.832032 7.164062-15.992188 15.996094-15.992188 8.835937 0 15.996094 7.160156 15.996094 15.992188zm0 0"
        fill="#ffc34c"
      ></path>
      <path
        d="m150.339844 253.101562c-18.988282 0-33.097656-4.28125-34.113282-4.597656-3.164062-.984375-4.929687-4.347656-3.945312-7.511718.984375-3.164063 4.347656-4.925782 7.507812-3.945313.390626.121094 39.628907 11.90625 73.257813-5.699219 2.9375-1.535156 6.558594-.402344 8.097656 2.53125 1.535157 2.9375.402344 6.5625-2.53125 8.101563-16.488281 8.628906-33.800781 11.121093-48.273437 11.121093zm0 0"
        fill="#fce575"
      ></path>
      <path
        d="m215.078125 208.714844c-8.738281-9.589844-13.679687-21.222656-13.21875-31.113282.164063-3.515624 1.144531-8.425781 4.898437-11.84375 1.9375-1.765624 4.332032-2.894531 7.03125-3.449218-8.28125-2.84375-16.078124-2.394532-20.96875 2.0625-3.753906 3.417968-4.734374 8.328125-4.898437 11.84375-.460937 9.890625 4.480469 21.523437 13.21875 31.117187 10.746094 11.792969 24.957031 17.777344 34.972656 15.722657-7.171875-2.460938-14.707031-7.390626-21.035156-14.339844zm0 0"
        fill="#ffb74b"
      ></path>
      <path
        d="m76.40625 56.503906c-8.738281-9.59375-13.679688-21.226562-13.21875-31.117187.164062-3.515625 1.148438-8.425781 4.898438-11.84375 1.9375-1.765625 4.332031-2.894531 7.03125-3.449219-8.28125-2.84375-16.074219-2.394531-20.96875 2.0625-3.75 3.417969-4.734376 8.328125-4.898438 11.84375-.460938 9.894531 4.480469 21.527344 13.21875 31.117188 10.746094 11.792968 24.960938 17.78125 34.972656 15.726562-7.171875-2.464844-14.703125-7.394531-21.035156-14.339844zm0 0"
        fill="#ffb74b"
      ></path>
      <g fill="#ffd551">
        <path d="m306.421875 133.820312c-19.507813-24.832031-55.578125-29.160156-80.410156-9.652343l-56.453125-71.855469c64.550781-50.71875 158-39.5 208.714844 25.050781 50.71875 64.554688 39.503906 158-25.050782 208.71875l-56.453125-71.855469c24.828125-19.507812 29.160157-55.578124 9.652344-80.40625zm0 0"></path>
        <path d="m349.445312 230.925781c-15.589843-19.84375-39.179687-27.320312-52.6875-16.707031-13.511718 10.613281-11.824218 35.300781 3.765626 55.144531 15.589843 19.839844 39.175781 27.320313 52.6875 16.707031 13.507812-10.617187 11.824218-35.304687-3.765626-55.144531zm0 0"></path>
        <path d="m222.238281 69.015625c-15.589843-19.839844-39.179687-27.320313-52.6875-16.707031-13.511719 10.617187-11.824219 35.304687 3.765625 55.144531 15.589844 19.84375 39.175782 27.320313 52.6875 16.707031 13.507813-10.613281 11.824219-35.304687-3.765625-55.144531zm0 0"></path>
      </g>
      <path
        d="m208.375 120.492188c3.496094.421874 8.5.261718 12.492188-2.875 9.710937-7.628907 7.34375-27.527344-5.167969-43.449219-8.015625-10.203125-18.671875-17-28.503907-18.179688-3.496093-.417969-8.5-.261719-12.492187 2.875-9.710937 7.628907-7.34375 27.527344 5.171875 43.453125 8.015625 10.199219 18.667969 16.996094 28.5 18.175782zm0 0"
        fill="#ffc34c"
      ></path>
      <path
        d="m395.335938 188.839844c0 8.835937-7.160157 15.996094-15.996094 15.996094-8.832032 0-15.996094-7.160157-15.996094-15.996094 0-8.832032 7.164062-15.996094 15.996094-15.996094 8.835937 0 15.996094 7.164062 15.996094 15.996094zm0 0"
        fill="#ffc34c"
      ></path>
      <path
        d="m214.761719 88.140625c-8.015625-10.203125-18.671875-16.996094-28.503907-18.179687-3.496093-.417969-8.5-.261719-12.492187 2.875-2.058594 1.621093-3.570313 3.792968-4.5625 6.363281-1.433594-8.636719.296875-16.25 5.5-20.335938 3.992187-3.136719 8.996094-3.296875 12.492187-2.875 9.828126 1.179688 20.488282 7.972657 28.503907 18.175781 9.855469 12.546876 13.410156 27.554688 9.730469 37.089844-1.242188-7.476562-4.859376-15.722656-10.667969-23.113281zm0 0"
        fill="#ffb74b"
      ></path>
      <path
        d="m341.132812 65.414062c-1.152343 0-2.320312-.332031-3.347656-1.027343-52.285156-35.238281-104.207031-14.570313-104.726562-14.359375-3.0625 1.261718-6.570313-.203125-7.828125-3.269532-1.257813-3.0625.207031-6.570312 3.273437-7.828124 2.355469-.972657 58.429688-23.285157 115.988282 15.507812 2.75 1.851562 3.472656 5.582031 1.621093 8.328125-1.15625 1.71875-3.050781 2.648437-4.980469 2.648437zm0 0"
        fill="#fce575"
      ></path>
      <path
        d="m364.390625 219.003906c-7.660156-9.75-17.25-16.507812-26.628906-19.605468-2.371094-.78125-3.503907-3.445313-2.359375-5.664063 10.003906-19.328125 8.523437-43.5625-5.777344-61.765625-14.859375-18.914062-39.328125-25.914062-61.121094-19.5625 14.453125 1.808594 28.226563 9.078125 37.917969 21.410156 19.507813 24.832032 15.179687 60.902344-9.652344 80.410156l5.867188 7.464844c-.574219 11.082032 3.78125 24.230469 12.828125 35.75 9.050781 11.519532 20.796875 18.859375 31.699218 20.925782l6.0625 7.710937c3.207032-2.519531 6.285157-5.152344 9.226563-7.878906.546875-.503907 1.089844-1.011719 1.625-1.527344l10.847656-11.484375c5.300781-12.394531 1.585938-30.753906-10.535156-46.183594zm0 0"
        fill="#ffc34c"
      ></path>
      <path
        d="m349.445312 230.925781c-15.589843-19.84375-39.179687-27.320312-52.6875-16.707031-13.511718 10.613281-11.824218 35.300781 3.765626 55.144531 15.589843 19.839844 39.175781 27.320313 52.6875 16.707031 13.507812-10.617187 11.824218-35.304687-3.765626-55.144531zm0 0"
        fill="#ffd551"
      ></path>
      <path
        d="m335.589844 282.40625c3.496094.421875 8.5.261719 12.488281-2.875 9.710937-7.628906 7.34375-27.527344-5.167969-43.449219-8.015625-10.203125-18.671875-17-28.503906-18.179687-3.496094-.417969-8.5-.261719-12.492188 2.875-9.707031 7.628906-7.339843 27.527344 5.171876 43.453125 8.015624 10.199219 18.671874 16.996093 28.503906 18.175781zm0 0"
        fill="#ffc34c"
      ></path>
      <path
        d="m341.972656 250.054688c-8.011718-10.203126-18.671875-17-28.5-18.179688-3.496094-.417969-8.5-.261719-12.492187 2.875-2.058594 1.617188-3.570313 3.792969-4.5625 6.363281-1.4375-8.636719.292969-16.25 5.5-20.339843 3.988281-3.132813 8.992187-3.292969 12.488281-2.871094 9.832031 1.179687 20.488281 7.972656 28.503906 18.175781 9.859375 12.546875 13.414063 27.554687 9.734375 37.089844-1.246093-7.476563-4.863281-15.722657-10.671875-23.113281zm0 0"
        fill="#ffb74b"
      ></path>
    </svg>
  ),
  tagliatelle: (props) => (
    <svg height="512" viewBox="0 0 60 58" width="512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Page-1" fill="none" fillRule="evenodd">
        <g id="036---Fettuccine" transform="translate(0 -1)">
          <path
            id="Path"
            d="m58.79 1.11c-.1909952-.12255993-.4295531-.14492474-.64-.06-7.51 3.94-19.78-2.12-25.17 6.27l-5.15 8.01-5.16 8.01c-3.99 6.2.77 12.54 3.33 18.85-6.8.29-14.55-1.41-18.54 4.8l-5.15 8.01-1.23 1.9c-.29551661.4649012-.28310695 1.0617557.03147815 1.5139717.31458509.4522161.86986798.6714196 1.40852185.5560283 7.54-2.34 18.39 2.22 23.37-5.53l.05.03 5.15-8.01 5.15-8.01-.04-.03c3.99-6.2-.76-12.54-3.32-18.84 6.82-.27 14.58 1.43 18.57-4.77l5.15-8.01s1.81-2.86 2.46-3.87c.140852-.30173498.0225654-.66097562-.27-.82z"
            fill="#f3d55b"
          ></path>
          <path
            id="Path"
            d="m32.57 40.75c-2.0602614.9489754-4.3016897 1.4402474-6.57 1.44-2.56-6.31-7.32-12.65-3.33-18.85l5.16-8.01c-.9317955 1.3921238-1.4580702 3.0159581-1.52 4.69-.33 6.87 6.6 13.86 6.26 20.73z"
            fill="#b19046"
          ></path>
          <path
            id="Path"
            d="m36.2 37.42c-.8894891 1.4154363-2.1432756 2.5656041-3.63 3.33.34-6.87-6.59-13.86-6.26-20.73.0619298-1.6740419.5882045-3.2978762 1.52-4.69l5.15-8.01c-.9231724 1.39696441-1.4517958 3.017385-1.53 4.69-.0032549 2.2632684.4810632 4.5006816 1.42 6.56l.01.01c2.56 6.3 7.31 12.64 3.32 18.84z"
            fill="#e4c05c"
          ></path>
          <g fill="#f0c419">
            <path
              id="Path"
              d="m56.6 5.8-5.15 8.01c-3.99 6.2-11.75 4.5-18.57 4.77l-.01-.01c-.9389368-2.0593184-1.4232549-4.2967316-1.42-6.56h.02c7.51-3.87 19.76 2.14 25.13-6.21z"
            ></path>
            <path
              id="Path"
              d="m31.09 45.46-5.15 8.01-.05-.03c-4.98 7.75-15.83 3.19-23.37 5.53-.53865387.1153913-1.09393676-.1038122-1.40852185-.5560283-.3145851-.452216-.32699476-1.0490705-.03147815-1.5139717l1.23-1.9c6.38-9.92 22.35.36 28.73-9.57z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  lasagne: (props) => (
    <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <g>
          <g>
            <g>
              <path
                d="m297.5 233.594s-9.224-6.072-14.746-6.072c-6.841 0-13.031 3.438-17.51 9.016-3.953 4.93-10.543 4.93-14.495 0-.769-.95-1.594-1.853-2.481-2.677l-.004-.004c-.008-.012-.02-.02-.027-.028-3.285-3.128-7.203-5.244-11.485-5.997-1.146-.204-2.32-.31-3.513-.31-6.841 0-13.035 3.438-17.49 9.016-3.953 4.93-10.562 4.93-14.519 0-.793-.989-1.629-1.9-2.508-2.708-.043-.043-.09-.082-.133-.126 0-.004-.004-.004-.004-.004-3.258-3.054-7.124-5.126-11.343-5.868h-.004c-1.146-.204-2.32-.31-3.513-.31-6.822 0-13.012 3.438-17.49 9.016-3.953 4.93-10.562 4.93-14.519 0-.793-.989-1.629-1.9-2.508-2.708-.016-.016-.039-.035-.055-.051 0 0 0-.004-.008-.004-3.277-3.105-7.167-5.201-11.426-5.946-1.138-.204-2.304-.306-3.489-.306-6.841 0-13.035 3.438-17.51 9.016-3.953 4.93-10.543 4.93-14.495 0-.769-.95-1.598-1.857-2.485-2.681-.008-.012-.02-.02-.027-.028-3.285-3.128-7.202-5.244-11.485-5.997-1.146-.204-2.32-.31-3.513-.31-8.223 0-15.504 4.977-19.998 12.666l-62.217-77.517c4.498-7.689 11.779-12.67 19.998-12.67 2.469 0 4.836.443 7.073 1.28l212.613 12.949 55.296 69.336z"
                fill="#ffdb47"
              ></path>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m248.264 233.857c-.008-.012-.02-.02-.027-.028-3.285-3.128-7.203-5.244-11.485-5.997l-13.526-16.854c-.899-1.123-.722-2.759.4-3.662 1.123-.899 2.759-.718 3.658.4z"
                  fill="#ebb11f"
                ></path>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m198.584 233.7c-3.258-3.054-7.124-5.126-11.343-5.868h-.004l-13.526-16.854c-.899-1.123-.722-2.759.4-3.662 1.123-.899 2.759-.718 3.658.4l20.607 25.678c.079.098.15.2.208.306z"
                  fill="#ebb11f"
                ></path>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m149.144 233.775c-3.277-3.105-7.167-5.201-11.426-5.946l-13.522-16.85c-.903-1.123-.722-2.759.4-3.662 1.119-.899 2.759-.718 3.658.4l20.732 25.831c.06.074.115.148.158.227z"
                  fill="#ebb11f"
                ></path>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m99.74 233.857c-.008-.012-.02-.02-.027-.028-3.285-3.128-7.202-5.244-11.485-5.997l-13.526-16.854c-.899-1.123-.722-2.759.4-3.662 1.123-.899 2.759-.718 3.658.4z"
                  fill="#ebb11f"
                ></path>
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="m297.48 188.448c-.024 0-9.216-6.045-14.727-6.045-6.841 0-13.031 3.438-17.51 9.016-.232.287-.483.573-.734.809-3.992 4.094-10.04 3.831-13.761-.809-.805-1.005-1.668-1.939-2.579-2.795-3.266-3.077-7.167-5.165-11.418-5.911h-.004c-1.146-.204-2.32-.31-3.509-.31-6.841 0-13.035 3.438-17.49 9.016-3.953 4.926-10.562 4.926-14.519 0-.836-1.04-1.727-2.006-2.677-2.889-3.246-3.026-7.108-5.079-11.312-5.817h-.004c-1.15-.204-2.32-.31-3.513-.31-6.822 0-13.012 3.438-17.49 9.016-3.953 4.926-10.562 4.926-14.519 0-.82-1.021-1.696-1.97-2.622-2.842l-.004-.004c-3.258-3.054-7.136-5.126-11.371-5.864-1.138-.204-2.304-.306-3.489-.306-6.841 0-13.035 3.438-17.51 9.016-3.953 4.926-10.543 4.926-14.495 0-.805-1.005-1.668-1.939-2.579-2.795-3.27-3.077-7.171-5.165-11.422-5.911-1.146-.204-2.32-.31-3.509-.31-8.223 0-15.504 4.977-19.998 12.666l-35.145-43.788-27.07-33.731c4.498-7.689 11.779-12.666 19.998-12.666 2.469 0 4.836.443 7.073 1.276l216.322 17.604z"
                fill="#ebb11f"
              ></path>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m248.17 188.625c-3.266-3.077-7.167-5.165-11.418-5.911h-.004l-13.522-16.854c-.899-1.119-.722-2.759.4-3.658 1.123-.899 2.759-.722 3.658.4z"
                  fill="#ffdb47"
                ></path>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m198.553 188.53c-3.246-3.026-7.108-5.079-11.312-5.817h-.004l-13.526-16.854c-.899-1.119-.722-2.759.4-3.658 1.123-.899 2.759-.722 3.658.4l20.607 25.674c.067.083.126.169.177.255z"
                  fill="#ffdb47"
                ></path>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m149.089 188.574c-3.258-3.054-7.136-5.126-11.371-5.864l-13.522-16.85c-.903-1.119-.722-2.759.4-3.658 1.119-.899 2.759-.722 3.658.4l20.732 25.831c.037.046.072.093.103.141z"
                  fill="#ffdb47"
                ></path>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m99.645 188.625c-3.27-3.077-7.171-5.165-11.422-5.911l-13.522-16.854c-.899-1.119-.722-2.759.4-3.658 1.123-.899 2.759-.722 3.658.4z"
                  fill="#ffdb47"
                ></path>
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m238.718 69.668-1.005-1.248c-4.455-5.369-10.5-8.655-17.172-8.655-6.841 0-13.035 3.438-17.51 9.02-1.558 1.943-3.525 3.12-5.581 3.525-.551.112-1.107.167-1.664.167-.459 0-.919-.038-1.374-.112h-.004c-2.159-.353-4.243-1.546-5.876-3.58-.506-.632-1.032-1.236-1.582-1.809-.887-.926-1.825-1.778-2.81-2.543-3.803-2.963-8.298-4.667-13.114-4.667-6.841 0-13.035 3.438-17.51 9.02-1.562 1.943-3.525 3.117-5.581 3.525-.551.112-1.107.167-1.664.167-.459 0-.918-.038-1.374-.112h-.004c-2.159-.353-4.243-1.546-5.876-3.58-.506-.628-1.032-1.232-1.582-1.806-.883-.93-1.825-1.782-2.81-2.547-3.8-2.96-8.298-4.667-13.118-4.667-6.837 0-13.012 3.438-17.486 9.02-1.562 1.943-3.533 3.12-5.593 3.525h-.004c-.551.112-1.107.167-1.664.167-.46 0-.92-.038-1.378-.112h-.004c-2.163-.353-4.247-1.55-5.876-3.58-.506-.632-1.032-1.236-1.582-1.809-.883-.93-1.825-1.782-2.81-2.547-3.796-2.96-8.278-4.663-13.094-4.663-6.841 0-13.035 3.438-17.51 9.02-1.562 1.943-3.525 3.117-5.581 3.525-.551.112-1.108.167-1.666.167-.46 0-.92-.038-1.376-.112-2.159-.353-4.243-1.546-5.876-3.58-.506-.632-1.032-1.236-1.582-1.809-.887-.926-1.825-1.778-2.81-2.543-3.803-2.963-8.302-4.667-13.118-4.667-8.219 0-15.5 4.977-19.998 12.666l62.216 77.52c4.494-7.689 11.775-12.67 19.998-12.67 1.193 0 2.359.106 3.505.306 1.503.263 2.963.695 4.365 1.28 2.571 1.072 4.946 2.649 7.061 4.643h.004c.911.856 1.77 1.79 2.575 2.791.573.714 1.201 1.323 1.868 1.829 1.635 1.244 3.507 1.865 5.379 1.865 2.636 0 5.272-1.232 7.248-3.695 4.475-5.577 10.668-9.02 17.51-9.02 1.181 0 2.343.102 3.478.302h.004c1.503.259 2.96.691 4.361 1.276 2.551 1.06 4.906 2.622 7.01 4.588 0 0 .004 0 .004.004.93.871 1.809 1.825 2.63 2.85.133.169.275.33.416.487 1.923 2.139 4.383 3.208 6.844 3.208 2.641 0 5.282-1.232 7.259-3.695 4.479-5.577 10.668-9.02 17.49-9.02 1.189 0 2.359.106 3.505.306 1.503.263 2.963.695 4.365 1.28 2.52 1.052 4.859 2.591 6.947 4.533.004 0 .004 0 .004.004.954.887 1.849 1.853 2.685 2.897.09.114.184.224.283.334 1.941 2.24 4.459 3.36 6.978 3.36 2.64 0 5.281-1.231 7.258-3.694 4.455-5.577 10.649-9.02 17.49-9.02 1.193 0 2.359.106 3.505.306 1.503.263 2.963.695 4.365 1.28 2.571 1.072 4.946 2.649 7.061 4.643h.004c.911.856 1.77 1.79 2.575 2.791.573.714 1.201 1.323 1.868 1.829 1.635 1.244 3.507 1.865 5.379 1.865 2.636 0 5.272-1.232 7.248-3.695 4.478-5.577 10.668-9.02 17.51-9.02 5.511 0 14.703 6.049 14.727 6.049z"
              fill="#ffdb47"
            ></path>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m248.17 143.51c-2.116-1.994-4.49-3.572-7.061-4.643-1.401-.585-2.861-1.017-4.365-1.28l-13.518-16.842c-.899-1.123-.722-2.759.4-3.658 1.123-.903 2.759-.722 3.658.4z"
                  fill="#ebb11f"
                ></path>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m198.541 143.4c-2.088-1.943-4.427-3.482-6.947-4.533-1.401-.585-2.861-1.017-4.365-1.28l-13.518-16.842c-.899-1.123-.722-2.759.4-3.658 1.123-.903 2.759-.722 3.658.4l20.607 25.674c.063.078.118.157.165.239z"
                  fill="#ebb11f"
                ></path>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m149.081 143.447c-2.104-1.966-4.459-3.529-7.01-4.588-1.401-.585-2.857-1.017-4.361-1.276h-.004l-13.51-16.839c-.903-1.123-.722-2.759.4-3.658 1.119-.903 2.759-.722 3.658.4l20.732 25.831c.037.044.068.087.095.13z"
                  fill="#ebb11f"
                ></path>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m99.645 143.51c-2.116-1.994-4.49-3.572-7.061-4.643-1.401-.585-2.861-1.017-4.365-1.28l-13.518-16.842c-.899-1.123-.722-2.759.4-3.658 1.123-.903 2.759-.722 3.658.4z"
                  fill="#ebb11f"
                ></path>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m210.674 92.629c-.479.385-1.056.573-1.629.573-.761 0-1.515-.334-2.029-.973l-19.622-24.449c-.2-.247-.349-.522-.444-.805.55.573 1.075 1.178 1.582 1.809 1.633 2.033 3.717 3.226 5.876 3.58h.004c1.009.165 2.033.149 3.038-.055.098.02.196.039.294.055h.004l13.326 16.607c.899 1.119.722 2.759-.4 3.658z"
                  fill="#ebb11f"
                ></path>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m161.159 92.629c-.479.385-1.056.573-1.629.573-.761 0-1.515-.334-2.029-.973l-19.622-24.449c-.2-.247-.345-.518-.444-.801.55.573 1.075 1.178 1.582 1.806 1.633 2.033 3.717 3.226 5.876 3.58h.004c1.009.165 2.033.149 3.038-.055.098.02.196.039.294.055h.004l13.326 16.607c.899 1.118.723 2.758-.4 3.657z"
                  fill="#ebb11f"
                ></path>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m111.644 92.629c-.483.385-1.056.573-1.629.573-.761 0-1.515-.334-2.029-.973l-19.625-24.449c-.2-.247-.345-.522-.44-.805.55.573 1.076 1.178 1.582 1.809 1.629 2.029 3.713 3.226 5.876 3.58h.004c1.013.165 2.037.149 3.042-.055 0 0 0 .004.004 0 .094.024.192.039.287.055h.004l13.326 16.607c.897 1.119.717 2.759-.402 3.658z"
                  fill="#ebb11f"
                ></path>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m62.149 92.629c-.479.385-1.056.573-1.629.573-.761 0-1.515-.334-2.029-.973l-19.621-24.449c-.2-.247-.349-.522-.444-.805.55.573 1.075 1.178 1.582 1.809 1.633 2.033 3.717 3.226 5.876 3.58 1.009.165 2.037.149 3.042-.055.098.02.196.039.294.055l13.33 16.607c.898 1.119.722 2.759-.401 3.658z"
                  fill="#ebb11f"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  penne: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m440 24v320s-3.98 64.39-48 104-112 40-112 40v-320s3.98-64.39 48-104 112-40 112-40z"
        fill="#ffd33a"
      ></path>
      <path
        d="m72 488v-320s3.98-64.39 48-104 112-40 112-40v320s-3.98 64.39-48 104-112 40-112 40z"
        fill="#ffd33a"
      ></path>
      <path
        d="m344 376c-26.41 30.812-32 80-32 80s37.59-1.188 64-32 32-80 32-80-37.59 1.188-64 32z"
        fill="#ffb632"
      ></path>
      <g fill="#f2c837">
        <path d="m408 320c-4.418 0-8-3.582-8-8v-256c0-4.418 3.582-8 8-8s8 3.582 8 8v256c0 4.418-3.582 8-8 8z"></path>
        <path d="m376 320c-4.418 0-8-3.582-8-8v-240c0-4.418 3.582-8 8-8s8 3.582 8 8v240c0 4.418-3.582 8-8 8z"></path>
        <path d="m344 344c-4.418 0-8-3.582-8-8v-240c0-4.418 3.582-8 8-8s8 3.582 8 8v240c0 4.418-3.582 8-8 8z"></path>
        <path d="m312 392c-4.418 0-8-3.582-8-8v-256c0-4.418 3.582-8 8-8s8 3.582 8 8v256c0 4.418-3.582 8-8 8z"></path>
      </g>
      <path
        d="m168 136c26.41-30.812 32-80 32-80s-37.59 1.188-64 32-32 80-32 80 37.59-1.188 64-32z"
        fill="#ffb632"
      ></path>
      <path
        d="m104 464c-4.418 0-8-3.582-8-8v-256c0-4.418 3.582-8 8-8s8 3.582 8 8v256c0 4.418-3.582 8-8 8z"
        fill="#f2c837"
      ></path>
      <path
        d="m136 448c-4.418 0-8-3.582-8-8v-240c0-4.418 3.582-8 8-8s8 3.582 8 8v240c0 4.418-3.582 8-8 8z"
        fill="#f2c837"
      ></path>
      <path
        d="m168 424c-4.418 0-8-3.582-8-8v-240c0-4.418 3.582-8 8-8s8 3.582 8 8v240c0 4.418-3.582 8-8 8z"
        fill="#f2c837"
      ></path>
      <path
        d="m200 392c-4.418 0-8-3.582-8-8v-256c0-4.418 3.582-8 8-8s8 3.582 8 8v256c0 4.418-3.582 8-8 8z"
        fill="#f2c837"
      ></path>
    </svg>
  ),
  lentil: (props) => (
    <svg
      height="512"
      viewBox="0 0 512.224 512.224"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <ellipse cx="208.799" cy="228.82" fill="#a44f3e" rx="84.337" ry="84.341"></ellipse>
          <ellipse cx="92.014" cy="144.48" fill="#ca6e59" rx="84.337" ry="84.341"></ellipse>
          <path
            d="m92.014 60.139c-6.894 0-13.587.846-20 2.407 36.92 8.983 64.337 42.248 64.337 81.934s-27.417 72.951-64.337 81.934c6.413 1.56 13.106 2.407 20 2.407 46.578 0 84.337-37.76 84.337-84.341s-37.759-84.341-84.337-84.341z"
            fill="#bb5d4c"
          ></path>
          <ellipse cx="393.486" cy="342.465" fill="#a44f3e" rx="84.337" ry="84.341"></ellipse>
          <ellipse cx="309.148" cy="420.556" fill="#ca6e59" rx="84.337" ry="84.341"></ellipse>
          <path
            d="m309.148 336.215c-6.894 0-13.587.846-20 2.407 36.921 8.983 64.337 42.248 64.337 81.934s-27.417 72.951-64.337 81.934c6.413 1.56 13.106 2.407 20 2.407 46.578 0 84.337-37.761 84.337-84.341.001-46.58-37.758-84.341-84.337-84.341z"
            fill="#bb5d4c"
          ></path>
          <ellipse cx="420.336" cy="92.242" fill="#ca6e59" rx="84.337" ry="84.341"></ellipse>
          <path
            d="m504.461 86.259c-3.304-46.463-43.646-81.45-90.107-78.146-4.796.341-9.461 1.098-13.984 2.194 34.645 8.465 61.425 38.466 64.09 75.952 2.963 41.666-24.876 78.391-64.16 87.916 8.297 2.027 17.04 2.833 26.017 2.194 46.462-3.303 81.448-43.647 78.144-90.11z"
            fill="#bb5d4c"
          ></path>
        </g>
        <g>
          <path d="m300.636 228.821c.905-59.906-59.603-105.445-116.878-88.374-2.665-76.253-96.013-116.014-152.765-64.582-7.244 6.447 2.728 17.651 9.973 11.205 48.623-43.976 128.355-8.2 127.886 57.411.001 42.368-34.469 76.839-76.837 76.839-57.115.697-95.27-62.849-67.86-112.889 4.558-8.559-8.683-15.608-13.24-7.049-37.869 70.866 28.951 153.526 106.141 131.467 9.356 118.73 179.34 115.205 183.58-4.028zm-91.837 76.84c-42.932.057-77.835-35.578-76.805-78.511 27.254-13.234 47.023-39.556 51.084-70.745 48.635-18.185 103.497 20.349 102.557 72.416.001 42.37-34.468 76.84-76.836 76.84z"></path>
          <path d="m55.177 144.48c0-20.314 16.525-36.841 36.837-36.841 4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5c-28.583 0-51.837 23.256-51.837 51.841.343 9.921 14.653 9.934 15 0z"></path>
          <path d="m393.486 250.624c-23.098 0-45.174 8.607-62.162 24.235-15.562 14.318-25.607 33.364-28.668 54.088-47.621 3.343-85.345 43.15-85.345 91.608 3.191 113.612 163.314 124.583 182.679 13.507 26.807-1.923 51.77-15.638 67.736-37.527 5.715-7.834-6.403-16.675-12.118-8.84-12.956 17.763-32.99 29.094-54.643 31.234-.82-46.983-37.092-85.472-83.152-89.803 5.682-35.803 39.297-64.129 75.673-63.502 50.014-.743 88.059 49.627 74.026 97.511-2.531 9.086 11.82 13.464 14.45 4.025 16.772-57.238-28.703-117.417-88.476-116.536zm-7.5 169.932c0 42.37-34.469 76.841-76.837 76.841-101.795-3.863-101.767-149.834.001-153.682 42.367 0 76.836 34.471 76.836 76.841z"></path>
          <path d="m301.649 376.215c0 4.143 3.358 7.5 7.5 7.5 20.312 0 36.837 16.526 36.837 36.841 0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5c0-28.585-23.254-51.841-51.837-51.841-4.143 0-7.5 3.358-7.5 7.5z"></path>
          <path d="m360.167 161.625c60.866 53.358 157.972 4.926 151.775-75.9-3.544-49.859-48.198-88.634-98.119-85.094-80.807 5.225-115.212 108.501-53.656 160.994zm54.719-146.031c41.792-2.981 79.124 29.432 82.094 71.197 3.005 42.264-28.933 79.092-71.194 82.097-41.783 2.977-79.123-29.418-82.094-71.196-3.005-42.263 28.933-79.092 71.194-82.098z"></path>
          <path d="m420.248 144.085c9.927-.344 9.927-14.657 0-15-19.19 0-35.291-15.036-36.656-34.23-.294-4.131-3.89-7.255-8.013-6.949-4.132.294-7.243 3.882-6.949 8.014 1.92 27.008 24.593 48.165 51.618 48.165z"></path>
        </g>
      </g>
    </svg>
  ),
  peas: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <path
            d="m492.795 25.024-15.651 7.933c-8.037 4.074-16.926 6.185-25.937 6.159l-33.984-.097c-17.102-.049-33.973 3.957-49.227 11.689l-363.908 184.454c-3.675 1.863-5.143 6.351-3.281 10.026l3.118 6.151c21.03 41.491 71.713 58.077 113.204 37.047l295.435-149.746c15.255-7.732 28.459-18.97 38.531-32.792l20.013-27.466c5.306-7.283 12.264-13.204 20.301-17.278l15.651-7.933c4.44-2.25 6.214-7.673 3.964-12.113l-6.117-12.068c-2.25-4.442-7.673-6.216-12.112-3.966z"
            fill="#7db723"
          ></path>
        </g>
        <g>
          <path
            d="m492.795 25.024-15.651 7.933c-2.342 1.187-4.757 2.202-7.225 3.051l-1.244.63c-8.037 4.074-14.995 9.995-20.301 17.278l-20.014 27.467c-10.072 13.822-23.276 25.06-38.531 32.792l-295.434 149.747c-28.985 14.692-62.455 11.021-87.168-6.671 22.674 37.11 70.444 51.134 109.903 31.134l295.435-149.746c15.255-7.732 28.459-18.97 38.531-32.793l20.013-27.466c5.306-7.283 12.264-13.204 20.301-17.278l15.651-7.933c4.44-2.25 6.214-7.673 3.964-12.113l-6.117-12.068c-2.251-4.44-7.674-6.214-12.113-3.964z"
            fill="#78a61f"
          ></path>
        </g>
        <g>
          <path
            d="m444.621 96.143-12.408 12.408c-6.372 6.372-14.163 11.142-22.735 13.92l-32.329 10.478c-16.269 5.273-31.057 14.327-43.15 26.421l-288.487 288.487c-2.913 2.913-2.913 7.636 0 10.549l4.876 4.876c32.892 32.892 86.22 32.892 119.112 0l234.207-234.207c12.093-12.093 21.148-26.881 26.421-43.15l10.478-32.329c2.778-8.572 7.549-16.363 13.92-22.735l12.408-12.408c3.519-3.519 3.519-9.226 0-12.745l-9.567-9.567c-3.52-3.518-9.227-3.518-12.746.002z"
            fill="#89c627"
          ></path>
        </g>
        <g>
          <path
            d="m444.621 96.143-12.408 12.408c-1.856 1.856-3.836 3.572-5.918 5.147l-.986.986c-6.372 6.372-11.142 14.163-13.92 22.735l-10.478 32.329c-5.273 16.269-14.327 31.057-26.421 43.15l-234.206 234.206c-22.978 22.978-55.929 29.899-84.92 20.772 33.091 28.217 82.854 26.688 114.136-4.593l234.207-234.207c12.093-12.093 21.148-26.881 26.421-43.15l10.478-32.329c2.778-8.572 7.549-16.363 13.92-22.735l12.408-12.408c3.519-3.519 3.519-9.226 0-12.745l-9.567-9.567c-3.52-3.519-9.227-3.519-12.746.001z"
            fill="#7db723"
          ></path>
        </g>
        <g>
          <circle cx="127.999" cy="434.052" fill="#cdf09c" r="22.954"></circle>
        </g>
        <g>
          <circle cx="161.812" cy="400.24" fill="#cdf09c" r="28.871"></circle>
        </g>
        <g>
          <circle cx="199.808" cy="362.244" fill="#cdf09c" r="28.871"></circle>
        </g>
        <g>
          <circle cx="237.804" cy="324.248" fill="#cdf09c" r="28.871"></circle>
        </g>
        <g>
          <circle cx="275.8" cy="286.252" fill="#cdf09c" r="28.871"></circle>
        </g>
        <g>
          <circle cx="313.796" cy="248.256" fill="#cdf09c" r="28.871"></circle>
        </g>
        <g>
          <circle cx="351.792" cy="210.26" fill="#cdf09c" r="28.871"></circle>
        </g>
        <g>
          <circle cx="384.115" cy="177.937" fill="#cdf09c" r="20.848"></circle>
        </g>
        <g>
          <path
            d="m122.455 411.776c8.717 8.982 8.64 23.327-.241 32.208-3.06 3.06-6.771 5.074-10.686 6.045.082.084.158.171.241.254 8.964 8.964 23.498 8.964 32.462 0s8.964-23.498 0-32.462c-5.904-5.903-14.223-7.917-21.776-6.045z"
            fill="#a1e42c"
          ></path>
        </g>
        <g>
          <path
            d="m158.099 371.615c.727.597 1.432 1.233 2.111 1.912 11.275 11.275 11.275 29.555 0 40.829-4.691 4.691-10.595 7.423-16.701 8.21 11.341 9.32 28.122 8.684 38.718-1.912 11.275-11.275 11.275-29.555 0-40.829-6.584-6.584-15.557-9.316-24.128-8.21z"
            fill="#a1e42c"
          ></path>
        </g>
        <g>
          <path
            d="m196.095 333.619c.727.597 1.432 1.233 2.111 1.912 11.275 11.275 11.275 29.555 0 40.829-4.691 4.691-10.595 7.423-16.701 8.21 11.341 9.32 28.122 8.684 38.718-1.912 11.275-11.275 11.275-29.555 0-40.829-6.584-6.584-15.557-9.316-24.128-8.21z"
            fill="#a1e42c"
          ></path>
        </g>
        <g>
          <path
            d="m234.091 295.623c.727.597 1.432 1.233 2.111 1.912 11.275 11.275 11.275 29.555 0 40.829-4.691 4.691-10.595 7.423-16.701 8.21 11.341 9.32 28.123 8.684 38.718-1.912 11.275-11.275 11.275-29.555 0-40.829-6.584-6.584-15.557-9.316-24.128-8.21z"
            fill="#a1e42c"
          ></path>
        </g>
        <g>
          <circle cx="170.937" cy="253.975" fill="#cdf09c" r="28.871"></circle>
        </g>
        <g>
          <path
            d="m167.224 225.35c.727.597 1.432 1.233 2.111 1.912 11.275 11.275 11.275 29.555 0 40.829-4.691 4.691-10.595 7.423-16.701 8.21 11.341 9.32 28.123 8.684 38.718-1.912 11.275-11.275 11.275-29.555 0-40.829-6.584-6.584-15.556-9.316-24.128-8.21z"
            fill="#a1e42c"
          ></path>
        </g>
        <g>
          <circle cx="200.286" cy="125.609" fill="#cdf09c" r="28.871"></circle>
        </g>
        <g>
          <path
            d="m196.573 96.984c.727.597 1.432 1.233 2.111 1.912 11.275 11.275 11.275 29.555 0 40.829-4.691 4.691-10.595 7.423-16.701 8.21 11.341 9.32 28.123 8.684 38.718-1.912 11.275-11.275 11.275-29.555 0-40.829-6.584-6.583-15.557-9.315-24.128-8.21z"
            fill="#a1e42c"
          ></path>
        </g>
        <g>
          <path
            d="m272.087 257.627c.727.597 1.432 1.233 2.111 1.912 11.275 11.275 11.275 29.555 0 40.829-4.691 4.691-10.595 7.423-16.701 8.21 11.341 9.32 28.122 8.684 38.718-1.912 11.275-11.275 11.275-29.555 0-40.829-6.584-6.584-15.557-9.316-24.128-8.21z"
            fill="#a1e42c"
          ></path>
        </g>
        <g>
          <path
            d="m310.083 219.631c.727.597 1.432 1.233 2.111 1.912 11.275 11.275 11.275 29.555 0 40.829-4.691 4.691-10.595 7.423-16.701 8.21 11.341 9.32 28.122 8.684 38.718-1.912 11.275-11.275 11.275-29.555 0-40.829-6.584-6.584-15.557-9.316-24.128-8.21z"
            fill="#a1e42c"
          ></path>
        </g>
        <g>
          <path
            d="m348.163 181.625c.491.429.975.87 1.443 1.338 11.275 11.275 11.275 29.555 0 40.829-4.712 4.712-10.649 7.447-16.786 8.221 11.341 9.91 28.58 9.469 39.386-1.338 11.275-11.275 11.275-29.555 0-40.829-6.562-6.563-15.497-9.298-24.043-8.221z"
            fill="#a1e42c"
          ></path>
        </g>
        <g>
          <path
            d="m377.893 158.04c7.065 8.19 6.718 20.568-1.053 28.339-2.468 2.468-5.403 4.184-8.52 5.155.336.39.684.774 1.054 1.144 8.142 8.142 21.342 8.141 29.483 0s8.142-21.342 0-29.483c-5.674-5.673-13.801-7.388-20.964-5.155z"
            fill="#a1e42c"
          ></path>
        </g>
        <g>
          <circle cx="237.804" cy="57.948" fill="#cdf09c" r="20.848"></circle>
        </g>
        <g>
          <path
            d="m231.582 38.052c7.065 8.19 6.718 20.568-1.053 28.339-2.468 2.468-5.403 4.184-8.52 5.155.336.39.684.774 1.054 1.144 8.142 8.142 21.342 8.141 29.483 0s8.142-21.342 0-29.483c-5.674-5.673-13.801-7.388-20.964-5.155z"
            fill="#a1e42c"
          ></path>
        </g>
      </g>
    </svg>
  ),
  biryani: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m73.693 453.74 7.503 30.787c1.125 4.615 5.259 7.862 10.009 7.862h329.587c4.75 0 8.884-3.248 10.009-7.862l7.503-30.787-182.307-10.302z"
        fill="#fc9744"
      />
      <path
        d="m438.301 453.744-7.5 30.782c-1.123 4.615-5.264 7.86-10.013 7.86h-39.569c4.749 0 8.88-3.245 10.003-7.86l7.51-30.782z"
        fill="#fb7722"
      />
      <g>
        <g>
          <circle cx="425.733" cy="207.626" fill="#fb3a82" r="35.809" />
          <path
            d="m461.546 207.63c0 19.769-16.04 35.809-35.809 35.809-4.662 0-9.132-.896-13.219-2.534 13.231-5.259 22.578-18.18 22.578-33.275 0-15.108-9.347-28.028-22.578-33.275 4.088-1.637 8.558-2.534 13.219-2.534 19.769 0 35.809 16.028 35.809 35.809z"
            fill="#fb1466"
          />
        </g>
        <g>
          <circle cx="393.407" cy="176.761" fill="#fb3a82" r="30.864" />
          <path
            d="m424.275 176.764c0 17.039-13.825 30.864-30.864 30.864-4.018 0-7.871-.773-11.394-2.184 11.404-4.533 19.46-15.669 19.46-28.68 0-13.022-8.056-24.158-19.46-28.68 3.523-1.411 7.376-2.184 11.394-2.184 17.039 0 30.864 13.815 30.864 30.864z"
            fill="#fb1466"
          />
        </g>
        <g>
          <path
            d="m325.462 156.643 4.892-19.614c.684-2.744 3.463-4.413 6.207-3.729l36.741 9.164c2.744.684 4.413 3.463 3.729 6.207l-4.892 19.614c-.684 2.744-3.463 4.413-6.207 3.729l-36.741-9.164c-2.744-.685-4.414-3.464-3.729-6.207z"
            fill="#a3e440"
          />
          <path
            d="m365.929 172.018-18.152-4.528c2.742.684 5.523-.986 6.207-3.729l4.894-19.622c.684-2.742-.986-5.523-3.729-6.207l18.152 4.528c2.742.684 4.413 3.465 3.729 6.207l-4.894 19.622c-.684 2.742-3.465 4.413-6.207 3.729z"
            fill="#99d53b"
          />
        </g>
        <g>
          <g>
            <g>
              <path
                d="m160.556 28.126c-4.074-7.373-13.347-10.523-21.083-7.188-3.455 1.49-6.122 4.006-7.84 7.022-3.416-.622-7.059-.197-10.422 1.494-7.526 3.783-11.072 12.912-8.042 20.772 2.401 6.226 8.035 10.091 14.134 10.597 4.525.376 8.428 3.347 10.347 7.463l23.4 50.181 21.007-9.796-23.4-50.181c-1.919-4.115-1.687-9.015.934-12.722 3.533-4.998 4.194-11.8.965-17.642z"
                fill="#fff2df"
              />
            </g>
            <path
              d="m184.428 97.071-.217-.466c-3.05-6.541-10.824-9.37-17.365-6.32l-10.104 4.712c-6.541 3.05-9.37 10.824-6.32 17.365l.217.466c3.816 8.183 3.797 17.542.375 25.898-5.966 14.569-5.604 33.007 2.417 50.207 13.649 29.271 44.302 43.866 68.466 32.598 24.163-11.267 32.686-44.13 19.037-73.401-8.02-17.2-21.911-29.329-36.907-34.124-8.601-2.75-15.783-8.751-19.599-16.935z"
              fill="#a34f41"
            />
            <path
              d="m240.93 148.126c13.653 29.28 5.128 62.138-19.035 73.406-2.063.962-4.159 1.735-6.308 2.316 11.854-15.36 14.046-39.252 3.837-61.147-8.02-17.198-21.916-29.326-36.906-34.123-8.599-2.742-15.786-8.746-19.6-16.924l-.218-.467c-2.408-5.163-7.763-8.02-13.12-7.488.922-3.703 3.444-6.971 7.16-8.704l10.102-4.711c6.545-3.052 14.321-.222 17.373 6.323l.218.467c3.814 8.179 10.992 14.187 19.59 16.929 15 4.793 28.887 16.925 36.907 34.123z"
              fill="#873f30"
            />
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m450.301 325.65c21.204 0 38.921-16.924 39.02-38.127.084-17.935-12.16-33.017-28.745-37.279-4.098-1.053-7.382-4.146-8.712-8.163-4.18-12.62-14.741-22.327-27.864-25.3-3.636-.824-6.671-3.216-8.464-6.484-5.089-9.282-13.907-16.226-24.441-18.813-3.277-.805-6.098-2.893-7.817-5.797-6.67-11.264-18.941-18.818-32.98-18.818-.026 0-.052 0-.078 0-4.426.009-8.554-2.148-10.945-5.872-6.811-10.607-18.704-17.636-32.246-17.636-3.359 0-6.615.435-9.718 1.25-4.59 1.205-9.382-.386-12.512-3.952-7.021-7.998-17.319-13.048-28.797-13.048-11.479 0-21.777 5.049-28.798 13.048-3.13 3.566-7.923 5.157-12.512 3.952-3.103-.814-6.359-1.25-9.718-1.25-13.542 0-25.435 7.03-32.246 17.636-2.391 3.724-6.52 5.881-10.945 5.872-.026 0-.052 0-.078 0-14.04 0-26.311 7.554-32.98 18.818-1.72 2.904-4.54 4.992-7.817 5.797-10.534 2.587-19.352 9.531-24.441 18.813-1.792 3.269-4.828 5.661-8.464 6.484-13.123 2.973-23.684 12.68-27.864 25.3-1.33 4.016-4.615 7.11-8.713 8.163-16.585 4.262-28.829 19.344-28.745 37.279.099 21.204 17.816 38.127 39.02 38.127z"
                  fill="#fee265"
                />
                <path
                  d="m489.315 287.527c-.093 21.201-17.812 38.127-39.013 38.127h-2.575c4.409-6.15 7.026-13.629 7.067-21.747.082-17.935-12.156-33.017-28.742-37.282-4.1-1.051-7.386-4.141-8.715-8.159-4.182-12.62-14.742-22.324-27.866-25.301-3.637-.824-6.665-3.214-8.458-6.48-5.089-9.282-13.907-16.236-24.446-18.821-3.276-.804-6.099-2.895-7.819-5.79-6.665-11.27-18.935-18.821-32.976-18.821h-.082c-4.419.01-8.55-2.153-10.94-5.872-6.81-10.611-18.708-17.637-32.245-17.637-3.358 0-6.614.433-9.725 1.247-4.584 1.205-9.375-.381-12.507-3.946-6.789-7.737-16.637-12.712-27.66-13.042 1.731-.731 3.307-1.875 4.595-3.348 7.015-7.994 17.317-13.042 28.794-13.042s21.778 5.048 28.794 13.042c3.132 3.575 7.922 5.161 12.517 3.956 3.101-.814 6.356-1.247 9.715-1.247 13.547 0 25.435 7.026 32.245 17.637 2.39 3.719 6.521 5.872 10.951 5.872h.072c14.041 0 26.311 7.551 32.986 18.811 1.72 2.905 4.533 4.996 7.819 5.8 10.528 2.586 19.347 9.529 24.436 18.811 1.793 3.276 4.832 5.666 8.468 6.49 13.125 2.967 23.684 12.682 27.856 25.301 1.339 4.007 4.615 7.108 8.715 8.159 16.583 4.265 28.832 19.346 28.739 37.282z"
                  fill="#fdd330"
                />
              </g>
            </g>
          </g>
          <g>
            <path
              d="m281.055 194.479c-2.419 0-4.8-1.131-6.306-3.253-.21-.296-.909-.736-1.974-.736-1.063 0-1.763.44-1.973.736-2.471 3.478-7.295 4.297-10.773 1.824-3.479-2.471-4.296-7.294-1.825-10.773 3.22-4.534 8.667-7.24 14.57-7.24s11.351 2.707 14.571 7.24c2.471 3.479 1.654 8.302-1.825 10.773-1.355.966-2.917 1.429-4.465 1.429z"
              fill="#f2c125"
            />
          </g>
          <g>
            <path
              d="m283.932 253.134c-2.418 0-4.8-1.132-6.307-3.253-.209-.296-.908-.736-1.973-.736-1.063 0-1.763.44-1.972.736-2.472 3.478-7.293 4.297-10.774 1.825-3.479-2.471-4.297-7.294-1.826-10.773 3.22-4.534 8.667-7.241 14.571-7.241s11.352 2.707 14.572 7.241c2.471 3.479 1.653 8.302-1.826 10.773-1.357.965-2.918 1.428-4.465 1.428z"
              fill="#f2c125"
            />
          </g>
          <g>
            <path
              d="m379.041 254.794c-1.547 0-3.109-.463-4.467-1.428-3.479-2.471-4.297-7.294-1.826-10.773 3.22-4.534 8.668-7.241 14.572-7.241 5.905 0 11.353 2.708 14.572 7.243 2.47 3.48 1.651 8.303-1.829 10.773-3.481 2.47-8.302 1.65-10.773-1.829-.209-.295-.907-.734-1.971-.734s-1.764.44-1.973.736c-1.505 2.121-3.886 3.253-6.305 3.253z"
              fill="#f2c125"
            />
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m68.36 82.121c-6.35-5.535-16.141-5.323-22.269.456-2.737 2.582-4.382 5.858-4.966 9.281-3.423.584-6.701 2.229-9.283 4.968-5.779 6.129-5.988 15.92-.452 22.27 4.385 5.03 11.002 6.734 16.906 5.124 4.381-1.195 9.064.263 12.275 3.474l39.152 39.152 16.39-16.39-39.152-39.152c-3.211-3.211-4.669-7.894-3.474-12.274 1.61-5.906-.095-12.524-5.127-16.909z"
                  fill="#fff2df"
                />
              </g>
              <path
                d="m114.373 138.743-.364-.364c-5.103-5.103-13.377-5.103-18.479 0l-7.883 7.883c-5.103 5.103-5.103 13.377 0 18.479l.364.364c6.385 6.385 9.568 15.186 9.21 24.208-.624 15.731 6.024 32.933 19.443 46.353 22.837 22.837 56.634 26.068 75.486 7.216s15.622-52.648-7.216-75.486c-13.419-13.419-30.621-20.066-46.352-19.443-9.023.358-17.824-2.825-24.209-9.21z"
                fill="#a34f41"
              />
              <path
                d="m184.929 167.394c22.844 22.844 26.071 56.637 7.219 75.489-1.61 1.61-3.315 3.052-5.136 4.334 5.886-18.488-.226-41.689-17.308-58.771-13.418-13.418-30.624-20.061-46.351-19.442-9.018.364-17.825-2.819-24.206-9.2l-.364-.364c-4.028-4.028-10.038-4.881-14.889-2.55-.401-3.795.852-7.729 3.752-10.628l7.882-7.882c5.106-5.106 13.382-5.106 18.488 0l.364.364c6.381 6.381 15.181 9.572 24.199 9.208 15.733-.626 32.932 6.024 46.35 19.442z"
                fill="#873f30"
              />
            </g>
            <g>
              <path
                d="m81.833 273.155c3.946-6.962 10.633-12.164 18.603-14.121 2.523-.619 4.693-2.227 6.017-4.462 5.134-8.67 14.579-14.485 25.385-14.485h.06c3.407.007 6.584-1.653 8.425-4.52 5.242-8.164 14.397-13.575 24.82-13.575 2.585 0 5.091.335 7.48.962 3.533.927 7.221-.297 9.631-3.042 5.404-6.156 13.33-10.043 22.166-10.043 8.835 0 16.762 3.887 22.166 10.043v53.242h-144.753z"
                fill="#fee265"
              />
              <g>
                <path
                  d="m106.447 262.3c-1.339 0-2.694-.348-3.93-1.079-3.672-2.174-4.885-6.913-2.711-10.585 6.674-11.272 18.949-18.274 32.033-18.274h.006c.877 0 1.588-.362 1.978-.969 6.884-10.723 18.593-17.126 31.32-17.126 3.193 0 6.369.409 9.441 1.215.654.171 1.348-.078 1.863-.665 7.069-8.053 17.266-12.672 27.973-12.672s20.903 4.619 27.973 12.672c2.815 3.207 2.497 8.089-.709 10.903-3.207 2.815-8.089 2.497-10.904-.709-4.136-4.711-10.099-7.413-16.359-7.413-6.261 0-12.223 2.702-16.359 7.413-4.393 5.005-11.063 7.079-17.398 5.418-1.793-.47-3.649-.709-5.519-.709-7.441 0-14.288 3.746-18.317 10.022-3.247 5.057-8.818 8.072-14.905 8.072-.013 0-.025 0-.038 0-7.694 0-14.874 4.098-18.781 10.695-1.445 2.437-4.017 3.791-6.657 3.791z"
                  fill="#f2c125"
                />
              </g>
              <g>
                <path
                  d="m212.698 257.478c-2.419 0-4.8-1.131-6.306-3.253-.21-.296-.909-.736-1.973-.736s-1.764.44-1.974.736c-2.47 3.478-7.296 4.297-10.773 1.824-3.479-2.471-4.296-7.294-1.825-10.773 3.22-4.534 8.668-7.24 14.571-7.24s11.35 2.707 14.57 7.24c2.471 3.479 1.654 8.302-1.825 10.773-1.355.966-2.918 1.429-4.465 1.429z"
                  fill="#f2c125"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m493.366 282.543h-474.732c-11.133 0-19.851 9.716-18.495 20.766 7.176 58.474 33.97 110.84 73.553 150.431h364.615c39.583-39.591 66.378-91.957 73.553-150.431 1.357-11.05-7.361-20.766-18.494-20.766z"
                  fill="#fca863"
                />
                <path
                  d="m493.367 282.54h-42.001c11.136 0 19.852 9.715 18.502 20.768-7.174 58.47-33.963 110.839-73.543 150.432h41.975c39.585-39.591 66.381-91.958 73.558-150.432 1.361-11.053-7.355-20.768-18.491-20.768z"
                  fill="#fc9744"
                />
              </g>
              <g>
                <path
                  d="m510.857 310.61c-.793 5.202-1.741 10.364-2.843 15.453h-504.027c-1.102-5.089-2.05-10.25-2.843-15.453z"
                  fill="#fb7722"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <path
            d="m238.664 166.285-19.368-5.788c-2.709-.81-4.249-3.662-3.44-6.372l10.842-36.281c.81-2.709 3.662-4.249 6.372-3.44l19.368 5.788c2.709.81 4.249 3.662 3.44 6.372l-10.842 36.281c-.81 2.709-3.663 4.249-6.372 3.44z"
            fill="#a3e440"
          />
          <path
            d="m255.882 126.566-5.357 17.925c.809-2.708-.732-5.562-3.44-6.372l-19.377-5.791c-2.708-.809-5.562.732-6.372 3.44l5.357-17.925c.809-2.708 3.664-4.249 6.372-3.44l19.377 5.791c2.708.81 4.249 3.664 3.44 6.372z"
            fill="#99d53b"
          />
        </g>
        <g>
          <path
            d="m311.427 226.129.523-20.208c.073-2.827 2.424-5.059 5.251-4.986l37.854.98c2.827.073 5.059 2.424 4.986 5.251l-.523 20.208c-.073 2.827-2.424 5.059-5.251 4.986l-37.854-.98c-2.827-.074-5.059-2.425-4.986-5.251z"
            fill="#a3e440"
          />
          <path
            d="m354.265 232.364-18.702-.484c2.825.073 5.178-2.16 5.251-4.986l.524-20.217c.073-2.825-2.16-5.178-4.986-5.251l18.702.484c2.825.073 5.059 2.425 4.986 5.251l-.524 20.217c-.073 2.826-2.426 5.06-5.251 4.986z"
            fill="#99d53b"
          />
        </g>
      </g>
    </svg>
  ),
  'red-beans': (props) => (
    <svg
      height="512"
      viewBox="0 0 64 64"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_2079285"
      {...props}
    >
      <g id="_20-haricot" data-name="20-haricot">
        <path
          d="m28 36a10.2 10.2 0 0 0 .2 2v.031c-.07 0-.13-.011-.2-.011v-.02a14.566 14.566 0 0 1 -2.99-.29 8.618 8.618 0 0 1 -4.66-2.8 26.789 26.789 0 0 0 7.76-1.91h.03c-.09.979-.14 1.989-.14 3z"
          fill="#f7fafd"
        ></path>
        <path
          d="m16.88 34.859a12.583 12.583 0 0 0 7.89 6.171 1.583 1.583 0 0 1 1.22 1.65v.03a1.414 1.414 0 0 1 -1.78 1.24 15.734 15.734 0 0 1 -10.03-7.831 1.415 1.415 0 0 1 .78-2.03l.02-.01a1.6 1.6 0 0 1 1.9.78z"
          fill="#ffdfb8"
        ></path>
        <path
          d="m28.15 18.029a1.374 1.374 0 0 1 -.37 2.07 15.588 15.588 0 0 1 -12.32 1.5 1.364 1.364 0 0 1 -.86-1.92l.01-.02a1.556 1.556 0 0 1 1.85-.76 12.358 12.358 0 0 0 9.69-1.18 1.563 1.563 0 0 1 1.98.29z"
          fill="#e7c699"
        ></path>
        <path
          d="m49.14 25.879a12.582 12.582 0 0 0 -6.17 7.89 1.583 1.583 0 0 1 -1.65 1.22h-.03a1.414 1.414 0 0 1 -1.24-1.78 15.735 15.735 0 0 1 7.83-10.03 1.415 1.415 0 0 1 2.03.78l.01.02a1.6 1.6 0 0 1 -.78 1.9z"
          fill="#e7c699"
        ></path>
        <path
          d="m49.71 38.009a1.415 1.415 0 0 1 1.24 1.781 15.735 15.735 0 0 1 -7.83 10.03 1.415 1.415 0 0 1 -2.03-.78l-.01-.02a1.6 1.6 0 0 1 .78-1.9 12.582 12.582 0 0 0 6.17-7.89 1.584 1.584 0 0 1 1.65-1.221z"
          fill="#ffdfb8"
        ></path>
        <path
          d="m15.39 15.7a9.185 9.185 0 0 0 8.63-.41 13.486 13.486 0 0 0 2.27-1.84l.01.02a9.055 9.055 0 0 1 12.22-.19c-5.49 3.969-9.59 11.22-10.38 19.72h-.03a26.789 26.789 0 0 1 -7.76 1.91 10.649 10.649 0 0 1 -1.9-3.16 9.1 9.1 0 0 0 -14.23-3.69l-.05-.06a8.542 8.542 0 0 1 1.24-10.26 8.932 8.932 0 0 1 9.98-2.04zm10.76 2.02a12.358 12.358 0 0 1 -9.69 1.18 1.556 1.556 0 0 0 -1.85.76l-.01.02a1.364 1.364 0 0 0 .86 1.92 15.588 15.588 0 0 0 12.32-1.5 1.374 1.374 0 0 0 .37-2.07l-.02-.02a1.563 1.563 0 0 0 -1.98-.291z"
          fill="#b55a47"
        ></path>
        <path
          d="m15.39 15.7a8.909 8.909 0 0 0 -5.22-.56l-.02-.14a10.215 10.215 0 0 1 2.84-5.42c9.91-9.8 24.48-11.26 31.72-4.09l.69.68a8.774 8.774 0 0 1 2.28 3.83v.01a16.2 16.2 0 0 0 -9.16 3.27 9.055 9.055 0 0 0 -12.22.19l-.01-.02a13.486 13.486 0 0 1 -2.27 1.84 9.185 9.185 0 0 1 -8.63.41z"
          fill="#a25040"
        ></path>
        <path
          d="m20.35 34.909a8.618 8.618 0 0 0 4.66 2.8 14.566 14.566 0 0 0 2.99.291v.02c.07 0 .13.011.2.011a9.244 9.244 0 0 1 8.79 8.45 9.066 9.066 0 0 0 -3.99 7.619 10.559 10.559 0 0 1 -6 1.9c-14.37 0-26-9.5-26-20v-1a8.927 8.927 0 0 1 8.72-9 9.092 9.092 0 0 1 8.73 5.75 10.649 10.649 0 0 0 1.9 3.159zm4.42 6.121a12.583 12.583 0 0 1 -7.89-6.171 1.6 1.6 0 0 0 -1.9-.78l-.02.01a1.415 1.415 0 0 0 -.78 2.03 15.734 15.734 0 0 0 10.03 7.831 1.414 1.414 0 0 0 1.78-1.24v-.03a1.583 1.583 0 0 0 -1.22-1.65z"
          fill="#c8644f"
        ></path>
        <path
          d="m36.99 46.48a8.974 8.974 0 0 1 1.76-.93 9.332 9.332 0 0 0 5.96-6.56 14.576 14.576 0 0 0 .29-2.99h.02a9.26 9.26 0 0 1 8.2-8.96 6.282 6.282 0 0 1 .75-.04c4.96 0 9.03 4.749 9.03 10 0 14.371-9.5 26-20 26h-1a8.93 8.93 0 0 1 -9-8.72v-.18a9.066 9.066 0 0 1 3.99-7.62zm13.96-6.69a1.415 1.415 0 0 0 -1.24-1.781h-.03a1.584 1.584 0 0 0 -1.65 1.221 12.582 12.582 0 0 1 -6.17 7.89 1.6 1.6 0 0 0 -.78 1.9l.01.02a1.415 1.415 0 0 0 2.03.78 15.735 15.735 0 0 0 7.83-10.03z"
          fill="#c8644f"
        ></path>
        <path
          d="m42.97 33.769a12.582 12.582 0 0 1 6.17-7.89 1.6 1.6 0 0 0 .78-1.9l-.01-.02a1.415 1.415 0 0 0 -2.03-.78 15.735 15.735 0 0 0 -7.83 10.03 1.414 1.414 0 0 0 1.24 1.78h.03a1.583 1.583 0 0 0 1.65-1.22zm-4.22 11.781a8.974 8.974 0 0 0 -1.76.93 9.244 9.244 0 0 0 -8.79-8.45v-.03a10.2 10.2 0 0 1 -.2-2c0-1.01.05-2.02.14-3 .79-8.5 4.89-15.75 10.38-19.72a16.2 16.2 0 0 1 9.16-3.27c.11-.01.21-.01.32-.01h1a8.93 8.93 0 0 1 9 8.72 9.114 9.114 0 0 1 -4.78 8.28v.04a9.26 9.26 0 0 0 -8.2 8.96h-.02a14.576 14.576 0 0 1 -.29 2.991 9.332 9.332 0 0 1 -5.96 6.559z"
          fill="#b55a47"
        ></path>
        <path
          d="m36.99 46.48a9.245 9.245 0 0 0 -8.79-8.451c-.07 0-.13-.01-.2-.01v-.019a14.561 14.561 0 0 1 -2.99-.291 8.618 8.618 0 0 1 -4.66-2.8 10.649 10.649 0 0 1 -1.9-3.16 9.1 9.1 0 0 0 -14.23-3.69 8.856 8.856 0 0 0 -2.545 3.5c.177-.173.354-.346.545-.5a9.094 9.094 0 0 1 14 3.161 1.644 1.644 0 0 1 .661.639 12.58 12.58 0 0 0 7.552 6.065c.489.048 1.009.076 1.568.076v.019c.07 0 .13.01.2.01a9.321 9.321 0 0 1 8.67 7.471 9.064 9.064 0 0 1 2.119-2.02z"
          fill="#db6d56"
        ></path>
        <path
          d="m37 56.28v-.18a9.066 9.066 0 0 1 3.99-7.62l.01-.007a1.641 1.641 0 0 1 .859-1.353 12.581 12.581 0 0 0 6.17-7.891 1.612 1.612 0 0 1 .964-1.1c0-.046.006-.085.006-.132h.02a9.26 9.26 0 0 1 8.2-8.96 6.282 6.282 0 0 1 .75-.04 7.693 7.693 0 0 1 1.477.155 8.328 8.328 0 0 0 -5.476-2.152 6.282 6.282 0 0 0 -.75.04 9.26 9.26 0 0 0 -8.2 8.96h-.02a14.576 14.576 0 0 1 -.29 2.991 9.332 9.332 0 0 1 -5.96 6.56 8.974 8.974 0 0 0 -1.76.93 9.066 9.066 0 0 0 -3.99 7.619v.18a8.912 8.912 0 0 0 7.063 8.511 8.943 8.943 0 0 1 -3.063-6.511z"
          fill="#db6d56"
        ></path>
        <path
          d="m59.435 29.152a7.728 7.728 0 0 0 -1.465-.152 6.282 6.282 0 0 0 -.75.04c-.034 0-.067.011-.1.014a10.526 10.526 0 0 1 1.88 5.946c0 14.371-9.5 26-20 26h-.5a8.953 8.953 0 0 0 1.553 1.786 9.188 9.188 0 0 0 1.947.214h1c10.5 0 20-11.63 20-26a10.51 10.51 0 0 0 -3.565-7.848z"
          fill="#b55a47"
        ></path>
        <path
          d="m40.32 19.28a16.2 16.2 0 0 1 9.16-3.27c.11-.01.21-.01.32-.01h1a8.952 8.952 0 0 1 6.976 3.276c.006-.186.029-.367.024-.556a8.93 8.93 0 0 0 -9-8.72h-1c-.11 0-.21 0-.32.01a16.2 16.2 0 0 0 -9.16 3.27c-5.49 3.97-9.59 11.22-10.38 19.72-.09.981-.14 1.991-.14 3a10.2 10.2 0 0 0 .2 2v.03a9.919 9.919 0 0 1 2.012.356c.927-8.232 4.951-15.232 10.308-19.106z"
          fill="#c8644f"
        ></path>
        <path
          d="m51.552 38.018a2.425 2.425 0 0 0 -1.786-1.008 2.6 2.6 0 0 0 -2.707 1.969 11.5 11.5 0 0 1 -5.669 7.26 2.614 2.614 0 0 0 -1.245 3.132 2.408 2.408 0 0 0 2.281 1.629 2.468 2.468 0 0 0 1.162-.293 16.751 16.751 0 0 0 8.336-10.674 2.442 2.442 0 0 0 -.372-2.015zm-.6 1.77a15.8 15.8 0 0 1 -7.837 10.037 1.419 1.419 0 0 1 -2.027-.781l-.01-.028a1.594 1.594 0 0 1 .785-1.9 12.535 12.535 0 0 0 6.163-7.893 1.591 1.591 0 0 1 1.649-1.22h.03a1.42 1.42 0 0 1 1.249 1.785z"
          fill="#b55a47"
        ></path>
        <path
          d="m34.871 48.5a8.773 8.773 0 0 0 -2.408-4.625 9.052 9.052 0 0 0 -3.334 5.688 2.727 2.727 0 0 1 -1.481 2.077l-.091.04a2.736 2.736 0 0 1 -1.322.193c-13.067-1.119-23.235-10.057-23.235-19.873v-1c0-.179.019-.352.029-.529a9.087 9.087 0 0 0 -.809.589c-.191.158-.368.331-.544.5a9.045 9.045 0 0 0 -.676 3.44v1c0 10.5 11.63 20 26 20a10.35 10.35 0 0 0 3.175-.5 10.667 10.667 0 0 0 2.825-1.4 8.992 8.992 0 0 1 .535-3.15 9.093 9.093 0 0 1 1.37-2.487c-.011.014-.024.025-.034.037z"
          fill="#b55a47"
        ></path>
        <path
          d="m25.021 40.059a11.5 11.5 0 0 1 -7.26-5.669 2.613 2.613 0 0 0 -3.132-1.245 2.418 2.418 0 0 0 -1.335 3.444 16.753 16.753 0 0 0 10.674 8.335 2.467 2.467 0 0 0 .607.075 2.414 2.414 0 0 0 2.415-2.232 2.6 2.6 0 0 0 -1.969-2.708zm.971 2.648a1.42 1.42 0 0 1 -1.78 1.247 15.8 15.8 0 0 1 -10.037-7.837 1.419 1.419 0 0 1 .781-2.027l.028-.01a1.594 1.594 0 0 1 1.9.785 12.535 12.535 0 0 0 7.893 6.163 1.591 1.591 0 0 1 1.22 1.649z"
          fill="#b55a47"
        ></path>
        <path
          d="m51.97 23a13.807 13.807 0 0 0 -2.183.763 1.6 1.6 0 0 1 .093.2l.01.02a1.6 1.6 0 0 1 -.78 1.9 12.582 12.582 0 0 0 -6.17 7.89 1.583 1.583 0 0 1 -1.65 1.22h-.03a1.286 1.286 0 0 1 -.2-.04 30.024 30.024 0 0 0 -.911 4.557.951.951 0 0 1 -1.705.462 10.951 10.951 0 0 0 -8.007-4.431c-.188.913-.34 1.844-.449 2.792a9.113 9.113 0 0 1 6.97 8.151 8.974 8.974 0 0 1 1.76-.93 9.332 9.332 0 0 0 5.96-6.56 14.576 14.576 0 0 0 .292-2.994h.02a9.26 9.26 0 0 1 8.2-8.96v-.04a9.105 9.105 0 0 0 4.737-7.3c-1.008 1.332-2.836 2.52-5.957 3.3z"
          fill="#a25040"
        ></path>
        <path
          d="m50.855 23.629a2.418 2.418 0 0 0 -1.4-1.463 2.444 2.444 0 0 0 -2.042.128 16.753 16.753 0 0 0 -8.335 10.674 2.42 2.42 0 0 0 2.157 3.022c.073.006.144.01.214.01a2.617 2.617 0 0 0 2.494-1.979 11.5 11.5 0 0 1 5.669-7.26 2.614 2.614 0 0 0 1.243-3.132zm-1.72 2.252a12.535 12.535 0 0 0 -6.163 7.893 1.591 1.591 0 0 1 -1.649 1.22h-.03a1.42 1.42 0 0 1 -1.247-1.78 15.8 15.8 0 0 1 7.837-10.037 1.419 1.419 0 0 1 2.027.781l.01.028a1.594 1.594 0 0 1 -.785 1.895z"
          fill="#a25040"
        ></path>
        <path
          d="m25.645 16.854a11.3 11.3 0 0 1 -8.9 1.084 2.551 2.551 0 0 0 -3.042 1.3 2.354 2.354 0 0 0 -.047 1.981 2.4 2.4 0 0 0 1.517 1.335 16.512 16.512 0 0 0 13.123-1.6 2.363 2.363 0 0 0 .6-3.594 2.58 2.58 0 0 0 -3.251-.506zm2.136 3.246a15.554 15.554 0 0 1 -12.325 1.5 1.365 1.365 0 0 1 -.86-1.916l.013-.026a1.559 1.559 0 0 1 1.848-.759 12.335 12.335 0 0 0 9.693-1.181 1.564 1.564 0 0 1 1.979.293l.019.022a1.363 1.363 0 0 1 -.367 2.067z"
          fill="#a25040"
        ></path>
        <g fill="#f7fafd">
          <ellipse
            cx="55.684"
            cy="32.695"
            rx="1.642"
            ry="2.286"
            transform="matrix(.707 -.707 .707 .707 -6.803 48.972)"
          ></ellipse>
          <ellipse
            cx="6.684"
            cy="33.695"
            rx="1.642"
            ry="2.286"
            transform="matrix(.707 -.707 .707 .707 -21.874 14.605)"
          ></ellipse>
          <ellipse
            cx="55.682"
            cy="37.708"
            rx=".825"
            ry="1.148"
            transform="matrix(.707 -.707 .707 .707 -10.35 50.44)"
          ></ellipse>
          <ellipse
            cx="8.682"
            cy="37.708"
            rx=".825"
            ry="1.148"
            transform="matrix(.707 -.707 .707 .707 -24.128 17.195)"
          ></ellipse>
          <ellipse
            cx="51.682"
            cy="13.708"
            rx=".825"
            ry="1.148"
            transform="matrix(.707 -.707 .707 .707 5.453 40.575)"
          ></ellipse>
        </g>
      </g>
    </svg>
  ),
  couscous: (props) => (
    <svg
      id="fi_7938456"
      enable-background="new 0 0 512 512"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m155.805 227.128s10.918-95.345-95.345-95.345c0 106.263 95.345 95.345 95.345 95.345"
          fill="#7c0"
        ></path>
        <path
          d="m155.805 227.128s75.139-59.699 0-134.838c-75.139 75.139 0 134.838 0 134.838"
          fill="#b9e600"
        ></path>
        <g>
          <path
            d="m229.026 184.062c-9.093-1.277-18.634-.23-27.731 3.538s-16.584 9.774-22.111 17.107c-7.05 1.823-13.797 5.112-19.762 9.865-9.601.116-18.587 2.776-26.324 7.332-9.093-1.277-18.634-.23-27.732 3.538-9.097 3.768-16.584 9.774-22.111 17.107-8.89 2.3-17.304 6.918-24.267 13.881s-11.581 15.377-13.881 24.267c-6.681 5.036-12.24 11.714-16.029 19.74h226.922l20-58.437-20-65.281c-9.847 0-19.062 2.683-26.974 7.343z"
            fill="#ffe477"
          ></path>
          <path
            d="m466.893 280.698c-2.3-8.89-6.919-17.304-13.881-24.267-6.963-6.963-15.377-11.581-24.267-13.881-5.527-7.333-13.014-13.339-22.111-17.107s-18.638-4.816-27.731-3.538c-7.737-4.557-16.722-7.217-26.324-7.332-5.965-4.753-12.712-8.041-19.762-9.865-5.527-7.333-13.014-13.339-22.111-17.107s-18.638-4.816-27.732-3.538c-7.912-4.66-17.128-7.344-26.974-7.344v123.719h226.922c-3.789-8.026-9.348-14.705-16.029-19.74z"
            fill="#ffcd00"
          ></path>
        </g>
        <g>
          <path
            d="m29.078 300.437c-.37.783-.743 1.563-1.078 2.371 0 64.563 52.339 116.902 116.902 116.902h111.098l20-76.377-20-42.896z"
            fill="#99503d"
          ></path>
          <path
            d="m482.922 300.437h-226.922v119.273h111.098c64.563 0 116.902-52.338 116.902-116.901-.335-.809-.708-1.589-1.078-2.372z"
            fill="#804231"
          ></path>
        </g>
        <g>
          <path d="m0 285.438v30h256l10-15.001-10-14.999z" fill="#c6715a"></path>
          <path d="m256 285.438h256v30h-256z" fill="#99503d"></path>
        </g>
      </g>
    </svg>
  ),
  poisChiche: (props) => (
    <svg
      id="fi_6113275"
      height="512"
      viewBox="0 0 256 256"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m110.0914 169.2313c-8.0537-22.05-10.9046-31.6895-10.9046-31.6895l-1.5738-1.1285s-10.0442.3908-33.5132-.1665-38.0663 24.5953-38.0663 24.5953a30.8572 30.8572 0 0 0 20.4677 48.4989 30.8574 30.8574 0 0 0 52.5016 3.8342s19.1429-21.8931 11.0886-43.9439z"
        fill="#ffd169"
      ></path>
      <path
        d="m84.65 194.3309-4.9634-2.3692a31.1847 31.1847 0 0 1 -41.5766 14.7112l-.0559.1171a30.7381 30.7381 0 0 0 8.4474 2.551 30.7446 30.7446 0 0 0 3.9306 5.8623c.3615.011.7226.03 1.0847.03a36.783 36.783 0 0 0 33.1332-20.9024z"
        fill="#ffbe1d"
      ></path>
      <path
        d="m79.5844 160.3617 12.8794-.3166 7.6914 10.3335 8.9085-3.9367c-7.2813-20.0782-9.8949-28.9118-9.8949-28.9118l-1.5735-1.1285s-9.658.3747-32.1379-.1356l-1.0216 6.9518 12.0162 4.646z"
        fill="#ffbe1d"
      ></path>
      <path
        d="m134.6814 115.5364c19.3072-13.3531 27.9163-18.5421 27.9163-18.5421l.695-1.8076s-2.91-9.6212-8.2884-32.4723-33.3991-30.6351-33.3991-30.6351a30.8567 30.8567 0 0 0 -41.7707 32.0346 30.8575 30.8575 0 0 0 9.527 51.7723s26.0124 13.0038 45.3199-.3498z"
        fill="#ffd169"
      ></path>
      <path
        d="m105.019 91.8451a31.1841 31.1841 0 0 1 -24.719-36.524l-.1275-.0247a30.727 30.727 0 0 0 -.3384 8.8174 30.7514 30.7514 0 0 0 -4.6841 5.2855 36.7248 36.7248 0 0 0 28.8282 27.8464z"
        fill="#ffbe1d"
      ></path>
      <path
        d="m135.5725 83.7791 3.5538 12.3831-8.06 10.0485 6.0553 7.628c17.5941-12.1083 25.4831-16.865 25.4831-16.865l.6953-1.8071s-2.7978-9.2514-7.972-31.1338l-6.9848.7646-1.4662 12.7993z"
        fill="#ffbe1d"
      ></path>
      <path
        d="m201.0311 133.53c-23.0546-4.4233-32.789-6.9314-32.789-6.9314l-1.7764.77s-4.827 8.8172-17.3666 28.6634 1.5353 45.2947 1.5353 45.2947a30.8572 30.8572 0 0 0 52.1232 7.367 30.857 30.857 0 0 0 30.271-43.0673s-8.9424-27.6729-31.9975-32.0964z"
        fill="#ffd169"
      ></path>
      <g fill="#ffbe1d">
        <path d="m204.9039 171.2946a31.1846 31.1846 0 0 1 -8.7476 43.2263l.0717.1082a30.7258 30.7258 0 0 0 6.53-5.9356 30.7648 30.7648 0 0 0 7.0531-.3593 36.7263 36.7263 0 0 0 -.3236-40.08z"></path>
        <path d="m177.7436 155.1418 6.3476-11.2108 12.8173-1.2874 1.2012-9.665c-20.9661-4.0729-29.8872-6.3707-29.8872-6.3707l-1.7765.77s-4.6419 8.4778-16.6327 27.5l5.4385 4.4489 10.161-7.92z"></path>
      </g>
    </svg>
  ),
};
